import React from 'react';
import Swal from 'sweetalert2';
import tema from "../../services/Plantilla";
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEye,
    faEyeSlash,
    faSearch,
    faAngleRight,
    faEdit,
    faFilter,
    faPlus,
    faTrashAlt,
    faClipboardCheck,
    faBackward,
    faCopy,
    faTable,
    faList,
    faPrint,
    faSave,
    faTimes,
    faImage,
    faBoxOpen, faExchangeAlt
} from '@fortawesome/free-solid-svg-icons';
import Url, { apiImage } from "../../services/Api"

class Listar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            load: '',
            Campo: '',
            IdCampo: '',
            id_boton_menu: 201,
            datosCargados: false,
            isLoadingOpen: false,
            ListaTablas: [],
            ListaOrdenes: [],
            Modulos: [],
            ListaCampos: [],
            TablaModal: [],
            TablaModalOriginal: [],
            Relaciones: [],
            filteredItems: [],
            Tab: [],
            ModeloFormulario: [],
            ModeloFormularioDetalle: [],
            ListaRelaciones: [],
            detallesExpandidos: {},
            detallesCargados: {},
            cargandoDetalle: {},
            permisos: { editar: 0, eliminar: 0, registrar: 0, consultar: 0 },

            // Estados para tablas hijas
            tablasHijas: [],
            hijosExpandidos: {},
            hijosCargados: {},
            cargandoHijos: {},
            modelosHijos: {},

            // Estados para el modal de formulario de detalle
            showFormModal: false,
            showFormModalPrincipal: false,
            ModeloFormularioDetalle: [],
            ModeloFormularioPrincipal: [],
            idmenuDetalle: null,
            idRegistroDetalle: null,
            btnGuadarDetalle: 0,
            btnGuadarPrincipal: 0,
            TablaRelacionActual: null,
            CampoRelacionActual: null,
            IdPadre: null,

            // Estado para controlar quÃƒÂ© modal de bÃƒÂºsqueda estÃƒÂ¡ activo
            modalActivo: 'principal',
            ordenSeleccionadaParaCambio: null,
            archivoSeleccionadoParaCobrador: null,

            OrdenExterna: '',
            Paciente: '',
            PacienteId: '',
            btnGuadar: 0,
            searchTerm: '',
            tablaActual: '',
            campoId: '',
            campoNombre: '',
            campoOpcional: '',
            idmenu: 0,
            iditem: null,

            // Control para evitar doble carga
            cargandoHijosMap: {},

            //heredar variables como el id del archivo, orden_externa y el nombre del paciente
            id_archivo: 0,

            // Estados para agregar masivo de productos
            showModalMasivo: false,
            productosDisponibles: [],
            cantidadesMasivo: {},
            busquedaMasivo: '',
            ordenIdMasivo: null,
            selectedOrders: {}, // { orderId: true/false }
            filtroTipoMasivo: '',
            idsPaqueteSeleccionado: null,
        };
    }

    ListarTabla = (pageNumber = 1) => {
        const u = localStorage.getItem('idusuario');
        const modulo = localStorage.getItem('Archivo');
        const id_tabla = localStorage.getItem('TablaId');

        try {
            const formData = { BUS_id: id_tabla };
            // Usamos las llaves originales: Archivo para el modulo y TablaId para el id
            authAxios.post(`master/index/${modulo}/${u}?page=${pageNumber}&_t=${Date.now()}`, formData)
                .then((datosRespuesta) => {
                    Swal.close();
                    if (document.getElementById('titulo')) {
                        document.getElementById('titulo').innerHTML = datosRespuesta.data.titulo;
                    }
                    this.VerRelaciones(datosRespuesta.data.tabla, id_tabla, u);
                    this.cargarTablasHijas();
                    this.setState({ ListaTablas: datosRespuesta.data.data.data || [] });

                    if (datosRespuesta.data.data.data && datosRespuesta.data.data.data.length > 0) {
                        this.setState({
                            Paciente: datosRespuesta.data.data.data[0].paciente || [],
                            PacienteId: datosRespuesta.data.data.data[0].paciente_id || [],
                            OrdenExterna: datosRespuesta.data.data.data[0].autorizacion || []
                        });
                    }
                    this.setState({ id_archivo: id_tabla });
                })
                .catch(error => {
                    console.error("Error al listar tabla:", error);
                    this.mostrarAlerta('error', 'Error', 'No se pudo cargar la informaciÃƒÂ³n');
                });
        } catch (e) {
            console.error(e);
        }
    }

    // FunciÃƒÂ³n para mostrar alertas con 6 segundos de duraciÃƒÂ³n
    mostrarAlerta = (icono, titulo, texto) => {
        return Swal.fire({
            icon: icono,
            title: titulo,
            text: texto,
            timer: 6000,
            timerProgressBar: true,
            showConfirmButton: true,
            confirmButtonText: 'Entendido'
        });
    }

    setInputValue = (ids, value) => {
        const input = ids
            .map((id) => document.getElementById(id))
            .find((element) => element !== null);

        if (input) {
            input.value = value ?? '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
        }

        console.warn("No se encontro ninguno de estos campos:", ids);
        return false;
    }

    normalizarDatosModal = (data) => {
        const rows = Array.isArray(data) ? data : (Array.isArray(data?.value) ? data.value : []);
        return rows.map((item, index) => ({
            ...item,
            id: item.id ?? item.codigo ?? index,
            nombre: item.nombre ?? item.descripcion ?? '',
        }));
    }

    ordenarTablasHijas = (tablas) => {
        if (!Array.isArray(tablas)) return [];
        
        const getPeso = (tabla) => {
            const tf = String(tabla.tablaforanea || tabla.tabla || '').toLowerCase().trim();
            if (tf === 'prescripcion' || tf === 'prescripciones') return 100;
            if (tf === 'evolucion') return 150;
            if (tf === 'laboratorios' || tf === 'laboratorio' || tf === 'remisiones') return 200;
            if (tf === 'incapacidad' || tf === 'incapacidades') return 300;
            if (tf === 'productos_asignados') return 400;
            return 0;
        };

        return [...tablas].sort((a, b) => {
            const pesoA = getPeso(a);
            const pesoB = getPeso(b);
            if (pesoA !== pesoB) {
                return pesoA - pesoB;
            }
            return 0;
        });
    }

    cargarTablasHijas() {
        authAxios.get("modulos/listarelaciones/ordenes")
            .then((datosRespuesta) => {
                console.log("Tablas hijas disponibles:", datosRespuesta.data);
                const tablaHijas = datosRespuesta.data.tabla || [];
                const sortedHijas = this.ordenarTablasHijas(tablaHijas);
                this.setState({ tablasHijas: sortedHijas });
            })
            .catch(error => {
                console.error("Error al cargar tablas hijas:", error);
            });
    }

    VerRelaciones = (tabla, id, u) => {
        // Cache busting: _t timestamp
        authAxios.get(`ordenes/relaciones/${tabla}/${id}/${u}?_t=${Date.now()}`)
            .then((datosRespuesta) => {
                console.log("Respuesta completa de relaciones:", datosRespuesta.data);

                const tablaRelaciones = datosRespuesta.data.tabla || [];
                const ordenesRelacionadas = datosRespuesta.data.relaciones || [];
                const modeloFormulario = datosRespuesta.data.modelo || [];
                const tab = datosRespuesta.data.nav || [];
                const permisos = datosRespuesta.data.permisos || [];

                this.setState({
                    ListaRelaciones: tablaRelaciones,
                    ListaOrdenes: ordenesRelacionadas,
                    ModeloFormulario: modeloFormulario,
                    Tab: tab,
                    permisos: permisos
                });
            })
            .catch(error => {
                console.error("Error al cargar relaciones:", error);
                this.mostrarAlerta('error', 'Error', 'No se pudieron cargar las relaciones');
            });
    }
    FuncionGenerica = async (campo, funcion) => {
        try {
            const response = await authAxios.get("funciones/buscar_funcion/" + funcion + "/" + campo);
            console.log("Datos de la funcion y de los campos:", response.data);

            let campos_f = response.data.funcion;
            let proceso = response.data.lista.operacion;

            // Declarar variables
            let c1 = 0, c2 = 0, c3 = 0;
            let res = null;

            if (campos_f.campo1 != null) {
                c1 = document.getElementById("detalle_" + campos_f.campo1 + "")?.value || 0;
            }
            if (campos_f.campo2 != null) {
                c2 = document.getElementById("detalle_" + campos_f.campo2 + "")?.value || 0;
            }
            if (campos_f.campo3 != null) {
                c3 = document.getElementById("detalle_" + campos_f.campo3 + "")?.value || 0;
            }

            if (campos_f.campo_resultado != null) {
                if (campos_f.tabla_secundaria != null) {
                    res = document.getElementById("edit_" + campos_f.campo_resultado + "");
                } else {
                    res = document.getElementById("detalle_" + campos_f.campo_resultado + "");
                }
            }

            let resultado;

            switch (proceso) {
                case "calcula_iva":
                    var subtotal = (parseInt(c2) * (parseInt(c1) / 100));
                    resultado = (parseFloat(c2) + subtotal) * c3;
                    break;
                case "suma":
                    resultado = parseFloat(c1) + parseFloat(c2);
                    break;
                case "resta":
                    resultado = parseFloat(c1) - parseFloat(c2);
                    break;
                case "multiplica":
                    resultado = parseFloat(c1) * parseFloat(c2);
                    break;
                case "division":
                    resultado = parseFloat(c1) / parseFloat(c2);
                    break;
                case "pasar_valor":
                    resultado = await this.PasarValor(funcion, campo, campos_f.campo_resultado, campos_f.campo2);
                    break;
                case "busca_precio":
                    resultado = await this.BuscarValor(funcion, campo, campos_f.campo_resultado, campos_f.campo2);
                    break;
                default:
                    resultado = '';
                    break;
            }

            if (res) {
                res.value = resultado;
            }

        } catch (error) {
            console.error("Error al buscar:", error);
            Swal.fire('Error', 'No se pudieron cargar los datos', 'error');
        }
    }
    BuscarValor = async (funcion, campo, resultado_campo, campo_extra) => {
        var valor = document.getElementById("detalle_" + campo + "").value;
        var id_registro = document.getElementById("detalle_" + campo_extra + "").value;

        var da = { funcion, campo, valor, id_registro };

        try {
            const response = await authAxios.post("funciones/buscarvalor", da);
            console.log("Datos recibidos:", response.data);
            let c = response.data.campo;
            let r = response.data.resultado;
            document.getElementById("detalle_" + c + "").value = r;

        } catch (error) {
            console.error("Error al buscar:", error);
            throw error;
        }
    }
    VerHijosDetalle = (ordenId, tabla, campo, index, forceReload = false) => {
        const tablasConOrdenInterna = ['formato_ingreso', 'formato_evolucion', 'enfermeria', 'turno_enfermeria', 'fisioterapia_inicial', 'fisioterapia_diaria', 'terapia_fonoaudiologia', 'terapia_fonoaudiologia_diaria', 'terapia_ocupacional', 'terapia_ocupacional_diaria', 'evolucion_general', 'formato_nutricion', 'formato_psicologia', 'procedimientos'];
        if (tablasConOrdenInterna.includes(tabla)) {
            campo = 'orden_interna';
            if (tabla === 'procedimientos') campo = 'orden';
        }
        if (tabla === 'productos_asignados') {
            campo = 'orden';
        }
        const key = `${tabla}-${ordenId}`;
        const estaExpandido = this.state.hijosExpandidos[key];

        if (estaExpandido && !forceReload) {
            this.setState(prevState => ({
                hijosExpandidos: {
                    ...prevState.hijosExpandidos,
                    [key]: false
                }
            }));
            return;
        }

        // Siempre recargamos si hay datos, independientemente de si ya estaban cargados
        if (forceReload || !this.state.cargandoHijosMap[key]) {
            this.setState(prevState => ({
                cargandoHijos: {
                    ...prevState.cargandoHijos,
                    [key]: true
                },
                cargandoHijosMap: {
                    ...prevState.cargandoHijosMap,
                    [key]: true
                }
            }));

            authAxios.get(`master/verrelacion/${tabla}/${campo}/${ordenId}?_t=${Date.now()}`)
                .then((datosRespuesta) => {
                    console.log(`Datos de tabla hija ${tabla}:`, datosRespuesta.data);

                    const datos = datosRespuesta.data.data?.data || datosRespuesta.data.data || [];
                    const modelo = datosRespuesta.data.modelo || [];
                    const relaciones = datosRespuesta.data.relaciones || [];

                    this.setState(prevState => ({
                        hijosCargados: {
                            ...prevState.hijosCargados,
                            [key]: {
                                datos: Array.isArray(datos) ? datos : [],
                                modelo: modelo,
                                relaciones: relaciones,
                                paginacion: datosRespuesta.data.data
                            }
                        },
                        modelosHijos: {
                            ...prevState.modelosHijos,
                            [tabla]: modelo
                        },
                        hijosExpandidos: {
                            ...prevState.hijosExpandidos,
                            [key]: true
                        },
                        cargandoHijos: {
                            ...prevState.cargandoHijos,
                            [key]: false
                        },
                        cargandoHijosMap: {
                            ...prevState.cargandoHijosMap,
                            [key]: false
                        }
                    }));
                })
                .catch(error => {
                    console.error(`Error al cargar detalles de ${tabla}:`, error);
                    this.setState(prevState => ({
                        cargandoHijos: {
                            ...prevState.cargandoHijos,
                            [key]: false
                        },
                        cargandoHijosMap: {
                            ...prevState.cargandoHijosMap,
                            [key]: false
                        }
                    }));
                    this.mostrarAlerta('error', 'Error', `No se pudieron cargar los detalles de ${tabla}`);
                });
        } else {
            // Si ya estÃƒÂ¡ cargando, simplemente expandimos
            this.setState(prevState => ({
                hijosExpandidos: {
                    ...prevState.hijosExpandidos,
                    [key]: true
                }
            }));
        }
    }

    VerDetalle = (iditem, ordenId, force = false) => {
        const estaExpandido = this.state.detallesExpandidos[ordenId];

        if (force || !estaExpandido) {
            // Si no estÃƒÂ¡ expandido, solo expandimos
            
        } else {
            // Si estÃƒÂ¡ expandido, recargamos los datos
            this.setState(prevState => ({
                cargandoDetalle: {
                    ...prevState.cargandoDetalle,
                    [ordenId]: true
                }
            }));

            // Primero limpiamos los datos existentes
            this.state.tablasHijas.forEach((tablaHija) => {
                const key = `${tablaHija.tablaforanea}-${ordenId}`;
                this.setState(prevState => ({
                    hijosCargados: {
                        ...prevState.hijosCargados,
                        [key]: undefined
                    },
                    cargandoHijosMap: {
                        ...prevState.cargandoHijosMap,
                        [key]: false
                    }
                }));
            });

            // Luego recargamos todas las tablas hijas
            setTimeout(() => {
                

                this.setState(prevState => ({
                    cargandoDetalle: {
                        ...prevState.cargandoDetalle,
                        [ordenId]: false
                    }
                }));
            }, 100);
        }

        if (estaExpandido && !force) {
            this.setState(prevState => ({
                detallesExpandidos: {
                    ...prevState.detallesExpandidos,
                    [ordenId]: false
                }
            }));
            return;
        }

        // Si no estÃƒÂ¡bamos cargando y no estÃƒÂ¡ expandido, mostramos loading y cargamos
        if (!this.state.cargandoDetalle[ordenId]) {
            this.setState(prevState => ({
                cargandoDetalle: {
                    ...prevState.cargandoDetalle,
                    [ordenId]: true
                }
            }));

            let tabla = "orden_detalle";
            let campo = "orden";

            const orden = this.state.ListaOrdenes.find(o => o.id === iditem);
            if (orden) {
                let tablaPermitida = null;
                if (orden.tipo_consulta && typeof orden.tipo_consulta === "string") {
                    const val = orden.tipo_consulta.toLowerCase();
                    if (val.includes("ingreso") || val.includes("valoracion")) { tablaPermitida = "formato_ingreso"; campo = "orden_interna"; }
                    else if (val.includes("evolucion general") || val.includes("evoluciÃ³n general")) { tablaPermitida = "evolucion_general"; campo = "orden_interna"; }
                    else if (val.includes("evolucion") || val.includes("mÃ©dico") || val.includes("medico") || val.includes("seguimiento")) { tablaPermitida = "formato_evolucion"; campo = "orden_interna"; }
                    else if (val.includes("turno") && val.includes("enfermer")) { tablaPermitida = "turno_enfermeria"; campo = "orden_interna"; }
                    else if (val.includes("enfermer")) { tablaPermitida = "enfermeria"; campo = "orden_interna"; }
                    else if (val.includes("procedimiento")) { tablaPermitida = "procedimientos"; campo = "orden"; }
                    else if (val.includes("fisioterapia") && val.includes("diaria")) { tablaPermitida = "fisioterapia_diaria"; campo = "orden_interna"; }
                    else if (val.includes("fisioterapia")) { tablaPermitida = "fisioterapia_inicial"; campo = "orden_interna"; }
                    else if ((val.includes("fonoaudiologia") || val.includes("fonoaudiologÃ­a")) && val.includes("diaria")) { tablaPermitida = "terapia_fonoaudiologia_diaria"; campo = "orden_interna"; }
                    else if (val.includes("fonoaudiologia") || val.includes("fonoaudiologÃ­a")) { tablaPermitida = "terapia_fonoaudiologia"; campo = "orden_interna"; }
                    else if (val.includes("ocupacional") && val.includes("diaria")) { tablaPermitida = "terapia_ocupacional_diaria"; campo = "orden_interna"; }
                    else if (val.includes("ocupacional")) { tablaPermitida = "terapia_ocupacional"; campo = "orden_interna"; }
                    else if (val.includes("nutricion") || val.includes("nutriciÃ³n")) { tablaPermitida = "formato_nutricion"; campo = "orden_interna"; }
                    else if (val.includes("psicologia") || val.includes("psicologÃ­a")) { tablaPermitida = "formato_psicologia"; campo = "orden_interna"; }
                    
                    if (tablaPermitida) tabla = tablaPermitida;
                } else if (orden.tipo_consulta) {
                    const tipo_consulta = parseInt(orden.tipo_consulta);
                    const tablas_mapeo = {
                        1: { tabla: "formato_ingreso", fk: "orden_interna" },
                        2: { tabla: "formato_evolucion", fk: "orden_interna" },
                        3: { tabla: "enfermeria", fk: "orden_interna" },
                        4: { tabla: "procedimientos", fk: "orden" },
                        5: { tabla: "formato_inicial_fisioterapia", fk: "orden_interna" },
                        6: { tabla: "terapia_fonoaudiologia", fk: "orden_interna" },
                        7: { tabla: "terapia_ocupacional", fk: "orden_interna" },
                        8: { tabla: "evolucion_general", fk: "orden_interna" }
                    };
                    if (tablas_mapeo[tipo_consulta]) {
                        tabla = tablas_mapeo[tipo_consulta].tabla;
                        campo = tablas_mapeo[tipo_consulta].fk;
                    }
                }
            }

            authAxios.get("ordenes/detalle/" + tabla + "/" + campo + "/" + iditem + `?_t=${Date.now()}`)
                .then((datosRespuesta) => {
                    const det = datosRespuesta.data.detalle || datosRespuesta.data;

                    this.setState(prevState => ({
                        detallesCargados: {
                            ...prevState.detallesCargados,
                            [ordenId]: Array.isArray(det) ? det : []
                        },
                        detallesExpandidos: {
                            ...prevState.detallesExpandidos,
                            [ordenId]: true
                        },
                        cargandoDetalle: {
                            ...prevState.cargandoDetalle,
                            [ordenId]: false
                        }
                    }));
                })
                .catch(error => {
                    console.error("Error al cargar detalles:", error);
                    this.setState(prevState => ({
                        cargandoDetalle: {
                            ...prevState.cargandoDetalle,
                            [ordenId]: false
                        }
                    }));
                    this.mostrarAlerta('error', 'Error', 'No se pudieron cargar los detalles');
                });
        }
    }

    // BÃƒÂƒÃ‚Âºsqueda para el modal principal
    Buscar = (tabla, id, nombre, campo, opcional) => {
        this.setState({
            isLoadingOpen: true,
            TablaModal: [],
            TablaModalOriginal: [],
            Campo: campo,
            IdCampo: id,
            tablaActual: tabla,
            campoId: id,
            campoNombre: nombre,
            campoOpcional: opcional,
            searchTerm: '',
            modalActivo: 'principal'
        });

        var da = { tabla, id, nombre, opcional };

        authAxios.post("master/relacion", da)
            .then((datosRespuesta) => {
                console.log("Datos del modal principal:", datosRespuesta.data);
                const datosModal = this.normalizarDatosModal(datosRespuesta.data);
                this.setState({
                    isLoadingOpen: false,
                    TablaModal: datosModal,
                    TablaModalOriginal: datosModal
                });

            })
            .catch(error => {
                console.error("Error al buscar:", error);
                this.setState({ isLoadingOpen: false });
                this.mostrarAlerta('error', 'Error', 'No se pudieron cargar los datos');
            });
    }

    // BÃƒÂƒÃ‚Âºsqueda para el modal de detalle
    BuscarDetalle = (tabla, id, nombre, campo, opcional) => {
        this.setState({
            isLoadingOpen: true,
            TablaModal: [],
            TablaModalOriginal: [],
            Campo: campo,
            IdCampo: id,
            tablaActual: tabla,
            campoId: id,
            campoNombre: nombre,
            campoOpcional: opcional,
            searchTerm: '',
            modalActivo: 'detalle'
        });

        var da = { tabla, id, nombre, opcional };

        authAxios.post("master/relacion", da)
            .then((datosRespuesta) => {
                console.log("Datos del modal para detalle:", datosRespuesta.data);
                const datosModal = this.normalizarDatosModal(datosRespuesta.data);
                this.setState({
                    isLoadingOpen: false,
                    TablaModal: datosModal,
                    TablaModalOriginal: datosModal
                });
            })
            .catch(error => {
                console.error("Error al buscar:", error);
                this.setState({ isLoadingOpen: false });
                this.mostrarAlerta('error', 'Error', 'No se pudieron cargar los datos');
            });
    }

    cambiarProfesional = (item) => {
        this.abrirModalCambioProfesional(item.id);
    }

    abrirModalCambioProfesional = (ordenId) => {
        this.setState({
            isLoadingOpen: true,
            TablaModal: [],
            TablaModalOriginal: [],
            modalActivo: 'cambiarProfesional',
            ordenSeleccionadaParaCambio: ordenId,
            searchTerm: ''
        });

        const da = {
            tabla: "users",
            id: "id",
            nombre: "nombre",
            opcional: "apellido"
        };

        authAxios.post("master/relacion", da)
            .then((datosRespuesta) => {
                const datosModal = this.normalizarDatosModal(datosRespuesta.data);
                this.setState({
                    isLoadingOpen: false,
                    TablaModal: datosModal,
                    TablaModalOriginal: datosModal
                });

                // Abrir el modal programÃƒÂƒÃ‚Â¡ticamente
                const modalElement = document.getElementById('ModalSelect');
                if (modalElement) {
                    const bootstrapModal = window.bootstrap.Modal.getOrCreateInstance(modalElement);
                    bootstrapModal.show();
                }
            })
            .catch(error => {
                console.error("Error al buscar profesionales:", error);
                this.setState({ isLoadingOpen: false });
                this.mostrarAlerta('error', 'Error', 'No se pudieron cargar los profesionales');
            });
    }

    cambiarProfesionalSubmit = (profesionalId) => {
        const { ordenSeleccionadaParaCambio } = this.state;
        if (!ordenSeleccionadaParaCambio) return;

        Swal.fire({
            title: 'Cambiando profesional...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const data = {
            orden: ordenSeleccionadaParaCambio,
            profesional: profesionalId
        };

        authAxios.post("cambiar_profesional", data)
            .then((res) => {
                if (res.data.Status === true) {
                    Swal.close();
                    this.mostrarAlerta('success', 'ÃƒÂ‚Ã‚Â¡ÃƒÂƒÃ¢Â€Â°xito!', res.data.Mensaje || 'Profesional cambiado correctamente').then(() => {
                        this.ListarTabla(1); // recargar
                    });
                } else {
                    Swal.close();
                    this.mostrarAlerta('error', 'Error', res.data.Mensaje || 'Error al cambiar profesional');
                }
            })
            .catch(error => {
                console.error("Error al cambiar profesional:", error);
                Swal.close();
                this.mostrarAlerta('error', 'Error', 'No se pudo cambiar el profesional');
            });
    }

    Addcobrador = (idArchivo) => {
        this.setState({
            isLoadingOpen: true,
            TablaModal: [],
            TablaModalOriginal: [],
            modalActivo: 'cobrador',
            archivoSeleccionadoParaCobrador: idArchivo,
            searchTerm: ''
        });

        const da = {
            tabla: "users",
            id: "id",
            nombre: "nombre",
            opcional: "apellido"
        };

        authAxios.post("master/relacion", da)
            .then((datosRespuesta) => {
                const datosModal = this.normalizarDatosModal(datosRespuesta.data);
                this.setState({
                    isLoadingOpen: false,
                    TablaModal: datosModal,
                    TablaModalOriginal: datosModal
                });

                const modalElement = document.getElementById('ModalSelect');
                if (modalElement) {
                    const bootstrapModal = window.bootstrap.Modal.getOrCreateInstance(modalElement);
                    bootstrapModal.show();
                }
            })
            .catch(error => {
                console.error("Error al buscar cobradores:", error);
                this.setState({ isLoadingOpen: false });
                this.mostrarAlerta('error', 'Error', 'No se pudieron cargar los usuarios');
            });
    }

    asignarCobradorSubmit = (usuarioId) => {
        const { archivoSeleccionadoParaCobrador } = this.state;
        if (!archivoSeleccionadoParaCobrador) return;

        Swal.fire({
            title: 'Asignando cobrador...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        authAxios.post("ordenes/quien_cobra", {
            archivo: archivoSeleccionadoParaCobrador,
            usuario: usuarioId
        })
            .then((res) => {
                if (res.data.Status === true) {
                    Swal.close();
                    this.setState({ archivoSeleccionadoParaCobrador: null });
                    this.mostrarAlerta('success', 'Exito', res.data.msj || 'Cobrador asignado correctamente').then(() => {
                        this.ListarTabla(1);
                    });
                } else {
                    Swal.close();
                    this.mostrarAlerta('error', 'Error', res.data.msj || 'No fue posible asignar el cobrador');
                }
            })
            .catch(error => {
                console.error("Error al asignar cobrador:", error);
                Swal.close();
                this.mostrarAlerta('error', 'Error', 'No fue posible asignar el cobrador');
            });
    }

    // FunciÃƒÂƒÃ‚Â³n para abrir el modal de formulario para nuevo registro en tabla hija
    abrirFormularioNuevo = (tabla, campo, idPadre, idMenu) => {
        this.setState({
            showFormModal: true,
            showFormModalPrincipal: false,
            ModeloFormularioDetalle: [],
            idmenuDetalle: idMenu,
            idRegistroDetalle: null,
            TablaRelacionActual: tabla,
            CampoRelacionActual: campo,
            IdPadre: idPadre,
            isLoadingOpen: true
        });

        Swal.fire({
            title: 'Cargando...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        const u = localStorage.getItem("idusuario");

        authAxios.get(`master/vermodelo/${idMenu}/${u}?_t=${Date.now()}`)
            .then((datosRespuesta) => {
                console.log("Datos del formulario para nuevo registro:", datosRespuesta.data);

                this.setState({
                    ModeloFormularioDetalle: datosRespuesta.data.modelo || [],
                    isLoadingOpen: false
                });

                Swal.close();

                setTimeout(() => {
                    this.limpiarFormularioDetalle();

                    if (campo) {
                        const campoHidden = document.getElementById("detalle_" + campo);
                        console.log("Asignando ID padre a campo:", "detalle_" + campo, "valor:", idPadre);
                        if (campoHidden) {
                            campoHidden.value = idPadre;
                        }
                    }
                }, 300);
            })
            .catch(error => {
                console.error("Error al cargar modelo de tabla hija:", error);
                Swal.close();
                this.setState({ isLoadingOpen: false });
                this.mostrarAlerta('error', 'Error', 'No se pudo cargar el formulario');
            });
    }

    // FunciÃƒÂƒÃ‚Â³n para abrir el modal de formulario para editar registro en tabla hija
    abrirFormularioEditar = (idMenu, idRegistro, tabla, campo, idPadre) => {
        this.setState({
            showFormModal: true,
            showFormModalPrincipal: false,
            idmenuDetalle: idMenu,
            idRegistroDetalle: idRegistro,
            TablaRelacionActual: tabla,
            CampoRelacionActual: campo,
            IdPadre: idPadre,
            ModeloFormularioDetalle: []
        });

        Swal.fire({
            title: 'Cargando...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        authAxios.get(`master/ver/${idMenu}/${idRegistro}?_t=${Date.now()}`)
            .then((datosRespuesta) => {
                const lista = datosRespuesta.data.result;
                const campos = datosRespuesta.data.modelo;

                console.log("Datos para editar:", lista);
                console.log("Modelo para editar:", campos);

                this.setState({ ModeloFormularioDetalle: campos });

                setTimeout(() => {
                    // Primero aseguramos que el modal estÃƒÂƒÃ‚Â© completamente renderizado
                    const formPrefix = "detalle_";

                    campos.forEach((item) => {
                        if (item.trae_tabla != null) {
                            const nameElement = document.getElementById(formPrefix + item.nombre_campo + "_name");
                            if (nameElement) {
                                nameElement.value = lista[item.nombre_campo + "_name"] || '';
                            }
                        }
                    });

                    campos.forEach((item) => {
                        if (item.tipo_dato === "blob") {
                            const imgElement = document.getElementById(formPrefix + "img_" + item.nombre_campo);
                            if (imgElement) {
                                imgElement.src = lista[item.nombre_campo] != null
                                    ? apiImage + lista[item.nombre_campo]
                                    : "https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg";
                            }
                        } else if (item.tipo_dato === "checkbox") {
                            const inputElement = document.getElementById(formPrefix + item.nombre_campo);
                            if (inputElement) {
                                inputElement.checked = (lista[item.nombre_campo] == "1" || lista[item.nombre_campo] == true);
                            }
                        } else if (item.tipo_dato === "radio") {
                            const inputElement = document.getElementById(formPrefix + item.nombre_campo);
                            if (inputElement) {
                                inputElement.checked = (lista[item.nombre_campo] == "1" || lista[item.nombre_campo] == true);
                            }
                            const hid = document.getElementById(`hidden_${formPrefix}${item.nombre_campo}`);
                            if (hid) {
                                hid.value = (lista[item.nombre_campo] == "1" || lista[item.nombre_campo] == true) ? "1" : "0";
                            }
                        } else {
                            const inputElement = document.getElementById(formPrefix + item.nombre_campo);
                            if (inputElement) {
                                inputElement.value = lista[item.nombre_campo] || '';
                            }
                        }
                    });

                    // Asignar el ID del registro al campo oculto
                    const subIdInput = document.getElementById("detalle_sub_id");
                    if (subIdInput) {
                        subIdInput.value = idRegistro;
                    }

                    // Asignar el ID del padre al campo correspondiente
                    if (campo && idPadre) {
                        const campoHidden = document.getElementById("detalle_" + campo);
                        if (campoHidden) {
                            campoHidden.value = idPadre;
                        }
                    }

                    Swal.close();
                }, 500); // Aumentamos el timeout para asegurar que el DOM estÃƒÂƒÃ‚Â© listo
            })
            .catch(error => {
                console.error("Error al cargar datos para editar:", error);
                Swal.close();
                this.mostrarAlerta('error', 'Error', 'No se pudieron cargar los datos');
            });
    }

    // FunciÃƒÂƒÃ‚Â³n para guardar el formulario de detalle
    saveDetalle = () => {
        Swal.fire({
            title: 'Guardando...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        this.setState({ btnGuadarDetalle: 1 });

        const form = document.getElementById("form_registro_detalle_hijo");
        const formData = new FormData(form);
        Array.from(form.elements).forEach(element => {
            if (element.type === 'checkbox') {
                if (!element.checked) {
                    formData.append(element.name, '0');
                } else {
                    formData.set(element.name, '1');
                }
            }
        });

        const u = localStorage.getItem("idusuario");
        const { idmenuDetalle, idRegistroDetalle, TablaRelacionActual, IdPadre, CampoRelacionActual } = this.state;

        if (!idRegistroDetalle && CampoRelacionActual && IdPadre) {
            formData.append(CampoRelacionActual, IdPadre);
        }

        const ordenHijaId = IdPadre;
        const tablaHijaActual = TablaRelacionActual;
        let campoRelacionActual = CampoRelacionActual;
        if (!campoRelacionActual) {
            const th = this.state.tablasHijas?.find(t => t.tablaforanea === tablaHijaActual);
            campoRelacionActual = th ? th.relacion_fk : 'orden_interna';
        }

        authAxios.post(`master/registrar/${idmenuDetalle}/${u}`, formData)
            .then((datosRespuesta) => {
                if (datosRespuesta.data.Status) {
                    const modal = document.getElementById('FormularioModalDetalleHijo');
                    if (modal) {
                        const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
                        if (bootstrapModal) {
                            bootstrapModal.hide();
                        }
                    }

                    const key = `${tablaHijaActual}-${ordenHijaId}`;
                    this.setState(prevState => ({
                        btnGuadarDetalle: 0,
                        showFormModal: false,
                        hijosExpandidos: {
                            ...prevState.hijosExpandidos,
                            [key]: true
                        },
                        cargandoHijosMap: {
                            ...prevState.cargandoHijosMap,
                            [key]: false
                        }
                    }), () => {
                        if (ordenHijaId && tablaHijaActual) {
                            this.VerHijosDetalle(ordenHijaId, tablaHijaActual, campoRelacionActual, null, true);
                        }
                        this.VerDetalle(ordenHijaId, ordenHijaId, true);
                        this.ListarTabla(1);
                    });

                    Swal.close();
                    this.mostrarAlerta('success',
                        idRegistroDetalle ? '¡Actualización exitosa!' : '¡Registro exitoso!',
                        datosRespuesta.data.msj
                    );
                } else {
                    Swal.close();
                    this.mostrarAlerta('error', 'Error', datosRespuesta.data.msj);
                    this.setState({ btnGuadarDetalle: 0 });
                }
            })
            .catch(error => {
                console.error("Error al guardar:", error);
                Swal.close();
                this.mostrarAlerta('error', 'Error', 'No se pudo guardar el registro');
                this.setState({ btnGuadarDetalle: 0 });
            });
    }

    // FunciÃƒÂƒÃ‚Â³n para guardar el formulario principal
    savePrincipal = () => {
        Swal.fire({
            title: 'Guardando...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        this.setState({ btnGuadarPrincipal: 1 });

        const form = document.getElementById("form_registro_detalle_principal");
        const formData = new FormData(form);
        Array.from(form.elements).forEach(element => {
            if (element.type === 'checkbox') {
                if (!element.checked) {
                    formData.append(element.name, '0');
                } else {
                    formData.set(element.name, '1');
                }
            }
        });

        const u = localStorage.getItem("idusuario");
        const { idmenu, iditem } = this.state;

        authAxios.post(`master/registrar/${idmenu}/${u}`, formData)
            .then((datosRespuesta) => {
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    this.mostrarAlerta('success', 'ÃƒÂ‚Ã‚Â¡ActualizaciÃƒÂƒÃ‚Â³n exitosa!', datosRespuesta.data.msj).then(() => {
                        this.setState({
                            btnGuadarPrincipal: 0,
                            showFormModalPrincipal: false
                        });

                        // Limpiamos los estados de relaciones para forzar recarga visual
                        this.setState({ ListaOrdenes: [] });
                        this.ListarTabla(1);
                        this.cerrarModalPrincipal();
                    });
                } else {
                    Swal.close();
                    this.mostrarAlerta('error', 'Error', datosRespuesta.data.msj);
                    this.setState({ btnGuadarPrincipal: 0 });
                }
            })
            .catch(error => {
                console.error("Error al guardar:", error);
                Swal.close();
                this.mostrarAlerta('error', 'Error', 'No se pudo guardar el registro');
                this.setState({ btnGuadarPrincipal: 0 });
            });
    }

    // FunciÃƒÂƒÃ‚Â³n para eliminar registro hijo

    actualizarCantidadGastada = (idRegistro, ordenId, nombreTabla, campoRelacion) => {
        Swal.fire({
            title: "¿Usar cantidad asignada?",
            text: "Se actualizará la cantidad usada para que sea igual a la cantidad asignada.",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: "Sí, actualizar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return authAxios.post('/ordenes/igualar_cantidad_gastada', { id: idRegistro })
                    .then(response => {
                        if (response.data.status === false) {
                            throw new Error(response.data.message || 'Error al actualizar');
                        }
                        return response.data;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            `Error: ${error.message}`
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire('¡Éxito!', 'La cantidad fue actualizada correctamente', 'success');
                const key = `${nombreTabla}-${ordenId}`;
                this.setState(prevState => ({
                    hijosExpandidos: {
                        ...prevState.hijosExpandidos,
                        [key]: true
                    },
                    cargandoHijosMap: {
                        ...prevState.cargandoHijosMap,
                        [key]: false
                    }
                }), () => {
                    this.VerHijosDetalle(ordenId, nombreTabla, campoRelacion, null, true);
                    this.VerDetalle(ordenId, ordenId, true);
                });
            }
        });
    }

    borrarRegistroHijo = (idm, id, tabla, campo, ordenId) => {
        const u = localStorage.getItem("idusuario");

        Swal.fire({
            title: "¿Está seguro de eliminar este registro?",
            text: "Esta acción no se puede deshacer",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return authAxios.get(`master/borrar/${idm}/${id}/${u}`)
                    .then(response => {
                        if (response.data.Status === false) {
                            throw new Error(response.data.msj || 'Error al eliminar el registro');
                        }
                        return response.data;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            error.response?.data?.msj || error.message || 'Error en la peticiÃƒÂƒÃ‚Â³n'
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                const key = `${tabla}-${ordenId}`;
                this.setState(prevState => ({
                    hijosExpandidos: {
                        ...prevState.hijosExpandidos,
                        [key]: true
                    },
                    cargandoHijosMap: {
                        ...prevState.cargandoHijosMap,
                        [key]: false
                    }
                }), () => {
                    this.VerHijosDetalle(ordenId, tabla, campo, null, true);
                    this.VerDetalle(ordenId, ordenId, true);
                    this.ListarTabla(1);
                });

                this.mostrarAlerta('success', '¡Eliminado!',
                    result.value?.msj || 'El registro ha sido eliminado correctamente'
                );
            }
        }).catch(error => {
            console.error("Error al eliminar:", error);
            this.mostrarAlerta('error', 'Error', 'No se pudo eliminar el registro');
        });
    }

    // FunciÃƒÂƒÃ‚Â³n para limpiar el formulario de detalle
    limpiarFormularioDetalle = () => {
        const formularioDetalle = document.getElementById('form_registro_detalle_hijo');
        if (formularioDetalle) {
            formularioDetalle.reset();
        }

        const subId = document.getElementById('detalle_sub_id');
        if (subId) {
            subId.value = '';
        }

        const inputs = document.querySelectorAll('[id^="detalle_"]');
        inputs.forEach(input => {
            if (input.type !== 'hidden' && input.id !== 'detalle_sub_id' && !input.id.includes('_name')) {
                input.value = '';
            }
        });

        const inputsName = document.querySelectorAll('[id$="_name"]');
        inputsName.forEach(input => {
            if (input.id.startsWith('detalle_')) {
                input.value = '';
            }
        });

        const imagenes = document.querySelectorAll('[id^="detalle_img_"]');
        imagenes.forEach(img => {
            img.src = "https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg";
        });
    }

    // FunciÃƒÂƒÃ‚Â³n para limpiar el formulario principal
    limpiarFormularioPrincipal = () => {
        const formularioPrincipal = document.getElementById('form_registro_detalle_principal');
        if (formularioPrincipal) {
            formularioPrincipal.reset();
        }

        const subId = document.getElementById('principal_sub_id');
        if (subId) {
            subId.value = '';
        }

        const imagenes = document.querySelectorAll('[id^="imgd"]');
        imagenes.forEach(img => {
            img.src = "https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg";
        });
    }

    // FunciÃƒÂƒÃ‚Â³n para cerrar el modal de detalle
    cerrarModalDetalle = () => {
        this.setState({ showFormModal: false });
        const modal = document.getElementById('FormularioModalDetalleHijo');
        if (modal) {
            const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
            if (bootstrapModal) {
                bootstrapModal.hide();
            }
        }
    }

    // FunciÃƒÂƒÃ‚Â³n para cerrar el modal principal
    cerrarModalPrincipal = () => {
        this.setState({ showFormModalPrincipal: false });
        const modal = document.getElementById('FormularioModalDetallePrincipal');
        if (modal) {
            const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
            if (bootstrapModal) {
                bootstrapModal.hide();
            }
        }
    }

    handleSearch = (e) => {
        const searchValue = e.target.value.toLowerCase();
        const { TablaModalOriginal, campoNombre, campoOpcional } = this.state;

        this.setState({ searchTerm: searchValue });

        if (!TablaModalOriginal || TablaModalOriginal.length === 0) {
            return;
        }

        if (searchValue.trim() === '') {
            this.setState({ TablaModal: TablaModalOriginal });
        } else {
            const filtered = TablaModalOriginal.filter(item => {
                const nombreValue = item[campoNombre] ? item[campoNombre].toString().toLowerCase() : '';
                let opcionalValue = '';
                if (campoOpcional && item[campoOpcional]) {
                    opcionalValue = item[campoOpcional].toString().toLowerCase();
                }
                const idValue = item.id ? item.id.toString().toLowerCase() : '';

                return nombreValue.includes(searchValue) ||
                    opcionalValue.includes(searchValue) ||
                    idValue.includes(searchValue);
            });

            this.setState({ TablaModal: filtered });
        }
    }

    // Seleccionar para modal principal
    SeleccionarPrincipal = (id, nombre, tabla) => {
        console.log("Seleccionando para principal:", id, nombre, tabla);
        const { Campo, IdCampo } = this.state;
        if (tabla === 'atenciones') {
            //llamar funcion para calcular el copago y el valor de la atencion
            const pac = document.getElementById("principal_paciente")?.value;
             const can = document.getElementById("principal_cantidad")?.value;
            const cod = id;
            if (pac) {
                this.BuscarPrecioAtencion(cod, pac, can)
            } else {
                this.mostrarAlerta('warning', 'Paciente requerido', 'Seleccione primero el paciente para calcular el valor de la atencion.');
            }
        }

        const campoNameElement = document.getElementById("principal_" + Campo + "_name");
        const campoIdElement = document.getElementById("principal_" + Campo);

        if (campoNameElement) {
            campoNameElement.value = nombre;
        } else {
            console.warn("Campo no encontrado: principal_" + Campo + "_name");
        }

        if (campoIdElement) {
            campoIdElement.value = id;
        } else {
            console.warn("Campo no encontrado: principal_" + Campo);
        }

        const modal = document.getElementById('ModalSelect');
        if (modal) {
            const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
            if (bootstrapModal) {
                bootstrapModal.hide();
            }
        }
    }
     // buscamos los precios
      BuscarPrecioAtencion = async (codigo,paciente,cantidad) => {
        try {
            Swal.fire({
                title: 'Calculando Precio...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            
            const response = await authAxios.get('/ordenes/calcula_pago/'+codigo+'/'+paciente+'/'+cantidad);

            if (response.data.status) {
                var precio = response.data.valor;
                var copago = response.data.copago;
                const copagoActualizado = this.setInputValue(["principal_valor_copago", "valor_copago"], copago);
                const atencionActualizada = this.setInputValue(["principal_valor_atencion", "valor_atencion"], precio);

                if (!copagoActualizado || !atencionActualizada) {
                    Swal.fire('Valor atencion', 'Pago calculado, pero no se encontraron los campos valor_copago o valor_atencion en el formulario.', 'warning');
                    return;
                }

                Swal.fire('Valor atencion', response.data.msj, 'success');
                //Swal.close();
            } else {
                Swal.fire('Error', 'La atencion no tiene precio configurado, debes de parametrizar el precio primero', 'error');
            }
        } catch (error) {
            console.error('Error al cargar productos:', error);
            Swal.fire('Error', 'Hubo un error al comunicarse con el servidor', 'error');
        }
    }
    // Seleccionar para modal de detalle
    SeleccionarDetalle = (id, nombre, tabla) => {
        console.log("Seleccionando para detalle:", id, nombre, tabla);
        const { Campo, IdCampo } = this.state;

        const campoNameElement = document.getElementById("detalle_" + Campo + "_name");
        const campoIdElement = document.getElementById("detalle_" + Campo);

        if (campoNameElement) {
            campoNameElement.value = nombre;
        } else {
            console.warn("Campo no encontrado: detalle_" + Campo + "_name");
        }

        if (campoIdElement) {
            campoIdElement.value = id;
        } else {
            console.warn("Campo no encontrado: detalle_" + Campo);
        }

        const modal = document.getElementById('ModalSelect');
        if (modal) {
            const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
            if (bootstrapModal) {
                bootstrapModal.hide();
            }
        }
    }

    abrirModalMasivo = async (ordenId) => {
        try {
            Swal.fire({
                title: 'Cargando productos...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await authAxios.get(`/ordenes/productos_activos?orden_id=${ordenId}`);

            if (response.data.status) {
                this.setState({
                    productosDisponibles: response.data.data,
                    showModalMasivo: true,
                    ordenIdMasivo: ordenId,
                    cantidadesMasivo: {},
                    busquedaMasivo: ''
                });
                Swal.close();
            } else {
                Swal.fire('Error', 'No se pudieron cargar los productos', 'error');
            }
        } catch (error) {
            console.error('Error al cargar productos:', error);
            Swal.fire('Error', 'Hubo un error al comunicarse con el servidor', 'error');
        }
    }

    cerrarModalMasivo = () => {
        this.setState({
            showModalMasivo: false,
            productosDisponibles: [],
            cantidadesMasivo: {},
            busquedaMasivo: '',
            ordenIdMasivo: null
        });
    }

    handleBusquedaMasivoChange = (e) => {
        this.setState({ busquedaMasivo: e.target.value });
    }

    handleCantidadMasivoChange = (idProducto, cantidad) => {
        this.setState(prevState => ({
            cantidadesMasivo: {
                ...prevState.cantidadesMasivo,
                [idProducto]: cantidad
            }
        }));
    }

    guardarMasivoProductos = async () => {
        const { productosDisponibles, cantidadesMasivo, ordenIdMasivo } = this.state;

        const productosAEnviar = productosDisponibles
            .map(p => ({
                id_producto: p.id,
                precio: p.precio,
                cantidad: parseInt(cantidadesMasivo[p.id]) || 0
            }))
            .filter(p => p.cantidad > 0);

        if (productosAEnviar.length === 0) {
            Swal.fire('AtenciÃƒÂƒÃ‚Â³n', 'Debe seleccionar al menos un producto e ingresar su cantidad', 'warning');
            return;
        }

        try {
            Swal.fire({
                title: 'Guardando...',
                text: 'Asignando productos masivamente',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await authAxios.post('/ordenes/agregar_masivo_productos', {
                orden_id: ordenIdMasivo,
                productos: productosAEnviar
            });

            if (response.data.status) {
                Swal.fire('ÃƒÂ‚Ã‚Â¡ÃƒÂƒÃ¢Â€Â°xito!', response.data.message, 'success');
                this.cerrarModalMasivo();

                // Mantener abierta la tabla hija 'productos_asignados'
                const key = `productos_asignados-${ordenIdMasivo}`;
                this.setState(prevState => ({
                    hijosExpandidos: {
                        ...prevState.hijosExpandidos,
                        [key]: true
                    },
                    cargandoHijosMap: {
                        ...prevState.cargandoHijosMap,
                        [key]: false
                    }
                }), () => {
                    this.VerHijosDetalle(ordenIdMasivo, 'productos_asignados', 'orden', null, true);
                    this.VerDetalle(ordenIdMasivo, ordenIdMasivo, true);
                    this.ListarTabla(1);
                });
            } else {
                Swal.fire('Error', response.data.message || 'Error al asignar productos', 'error');
            }
        } catch (error) {
            console.error('Error al guardar masivo:', error);
            Swal.fire('Error', 'Hubo un problema al guardar los productos', 'error');
        }
    }

    renderTablaHija = (tablaHija, ordenId, index, permisos) => {
        const key = `${tablaHija.tablaforanea}-${ordenId}`;
        const estaExpandido = this.state.hijosExpandidos[key];
        const datosCargados = this.state.hijosCargados[key];
        const cargando = this.state.cargandoHijos[key];

        const siempreVisibles = ['evolucion', 'laboratorios', 'productos_asignados', 'incapacidad', 'prescripcion'];
        const esSiempreVisible = siempreVisibles.includes(tablaHija.tablaforanea);

        

        const modelo = this.state.modelosHijos[tablaHija.tablaforanea] || [];
        const idMenu = modelo.length > 0 ? modelo[0]?.id_menu : 201;
        const aliasControl = modelo.find(item => item && item.alias_tabla && String(item.alias_tabla).trim() !== '')?.alias_tabla;
        const tituloMostrar = aliasControl || tablaHija.alias_tabla || tablaHija.nombre_tabla || tablaHija.tablaforanea || 'Tabla relacionada';

        return (
            <div key={key} className="mt-3 mb-3">
                <div
                    className="d-flex align-items-center justify-content-between p-2 bg-light rounded cursor-pointer"
                    style={{ cursor: 'pointer' }}
                >
                    <div
                        className="d-flex align-items-center flex-grow-1"
                        onClick={() => this.VerHijosDetalle(ordenId, tablaHija.tablaforanea, tablaHija.relacion_fk, index)}
                    >
                        <FontAwesomeIcon icon={estaExpandido ? faEyeSlash : faEye} className="me-2" />
                        <h6 className="mb-0">
                            <span className="badge bg-info p-2">
                                {tituloMostrar}
                            </span>
                            {datosCargados && (
                                <span className="badge bg-secondary ms-2">
                                    {datosCargados.datos.length} registros
                                </span>
                            )}
                        </h6>
                        {cargando && (
                            <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                        )}
                    </div>

                    <div onClick={(e) => e.stopPropagation()}>
                        {(permisos.registrar === 1) && idMenu === 225 && (
                            <button
                                type="button"
                                className="btn btn-warning btn-xs me-2"
                                onClick={() => this.abrirModalMasivo(ordenId)}
                                title="Agregar productos masivamente"
                            >
                                <FontAwesomeIcon icon={faPlus} /> Agregar Masivo
                            </button>
                        )}
                        {(permisos.registrar === 1) && esSiempreVisible && (
                            <button
                                type="button"
                                className="btn btn-success btn-xs"
                                onClick={() => {
                                    this.abrirFormularioNuevo(
                                        tablaHija.tablaforanea,
                                        tablaHija.relacion_fk,
                                        ordenId,
                                        idMenu
                                    );
                                }}
                                title="Agregar nuevo registro"
                            >
                                <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>)}
                    </div>
                </div>

                {estaExpandido && datosCargados && this.renderTablaHijaDetalle(datosCargados, tablaHija.tablaforanea, permisos, ordenId)}
            </div>
        );
    }

    renderTablaHijaDetalle = (datosCargados, nombreTabla, permisos, ordenId) => {
        const { datos, modelo } = datosCargados;
        const aliasControl = modelo?.find(item => item && item.alias_tabla && String(item.alias_tabla).trim() !== '')?.alias_tabla;
        const tablaHijaObj = this.state.tablasHijas?.find(t => t.tablaforanea === nombreTabla);
        const tituloMostrar = aliasControl || tablaHijaObj?.alias_tabla || tablaHijaObj?.nombre_tabla || nombreTabla;

        if (!datos || datos.length === 0) {
            return (
                <div className="alert alert-warning mt-2">
                    No hay registros en {tituloMostrar}
                </div>
            );
        }

        const camposVisibles = modelo.filter(campo =>
            campo.nombre_campo !== 'id' &&
            campo.mostrar_consulta === 'Si'
        );

        const idMenu = camposVisibles.length > 0 ? camposVisibles[0]?.id_menu : 201;

        const tablaHija = this.state.tablasHijas.find(t => t.tablaforanea === nombreTabla);
        const campoRelacion = tablaHija ? tablaHija.relacion_fk : null;

        return (
            <div className="table-responsive mt-2">
                <table className="table table-sm table-bordered table-striped text-white">
                    <thead className="table-success">
                        <tr>
                            {camposVisibles.map(campo => (
                                <th key={campo.id} className="small">
                                    {campo.nombre_titulo}
                                </th>
                            ))}
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {datos.map((registro, idx) => (
                            <tr key={registro.id || idx}>
                                {camposVisibles.map(campo => (
                                    <td key={campo.id} className="small">
                                        {this.renderCampoValor(registro, campo)}
                                    </td>
                                ))}
                                <td>
                                    <div className="btn-group" role="group">
                                        {(permisos.editar === 1) && (
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-xs"
                                                onClick={() => this.abrirFormularioEditar(
                                                    idMenu,
                                                    registro.id,
                                                    nombreTabla,
                                                    campoRelacion,
                                                    ordenId
                                                )}
                                                title="Editar"
                                            >
                                                <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                        )}
                                        {(permisos.eliminar === 1 || nombreTabla === 'productos_asignados') && (
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-xs"
                                                onClick={() => this.borrarRegistroHijo(
                                                    idMenu,
                                                    registro.id,
                                                    nombreTabla,
                                                    campoRelacion,
                                                    ordenId
                                                )}
                                                title="Eliminar"
                                            >
                                                <FontAwesomeIcon icon={faTrashAlt} />
                                            </button>
                                        )}
                                        {nombreTabla === 'productos_asignados' && (
                                            <button
                                                type="button"
                                                className="btn btn-info btn-xs ms-1"
                                                onClick={() => this.actualizarCantidadGastada(registro.id, ordenId, nombreTabla, campoRelacion)}
                                                title="Igualar cantidad gastada a cantidad asignada"
                                            >
                                                <FontAwesomeIcon icon={faClipboardCheck} />
                                            </button>
                                        )}
                                        {['prescripcion', 'laboratorios', 'incapacidad', 'evolucion', 'evolucion_general', 'formato_ingreso', 'formato_evolucion'].includes(nombreTabla) && (
                                            <button
                                                type="button"
                                                className="btn btn-success btn-xs"
                                                onClick={() => this.descargarPDFTablaHija(registro.id, nombreTabla)}
                                                title="Imprimir PDF"
                                            >
                                                <FontAwesomeIcon icon={faPrint} />
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    renderCampoValor = (registro, campo) => {
        const valor = registro[campo.nombre_campo];

        if (valor === null || valor === undefined) return '-';

        switch (campo.tipo_dato) {
            case 'blob':
                return valor ? (
                    <a href={apiImage + valor} target="_blank" rel="noopener noreferrer">
                        Ver archivo
                    </a>
                ) : '-';

            case 'int':
            case 'varchar':
            case 'text':
            default:
                if (typeof valor === 'string' && valor.length > 50) {
                    return valor.substring(0, 50) + '...';
                }
                return valor;
        }
    }
    verOrden = () => {
        const idArchivo = this.state.id_archivo || localStorage.getItem('TablaId');
        window.localStorage.setItem("Archivo", 200);
        window.localStorage.setItem("TablaId", idArchivo);
        window.localStorage.removeItem("OrdenId");
    }
    limpiarformulario = (idmenu) => {
        this.setState({
            idmenu: idmenu,
            iditem: null,
            ModeloFormularioPrincipal: this.state.ModeloFormulario,
            showFormModalPrincipal: true,
            showFormModal: false
        });

        setTimeout(() => {
            const form = document.getElementById("form_registro_detalle_principal");
            if (form) {
                form.reset();
            }

            const subIdInput = document.getElementById("principal_sub_id");
            if (subIdInput) {
                subIdInput.value = '';
            }

            const imagenes = document.querySelectorAll('[id^="imgd"]');
            imagenes.forEach(img => {
                img.src = "https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg";
            });
            document.getElementById("principal_orden_externa").value = this.state.OrdenExterna;
            document.getElementById("principal_paciente_name").value = this.state.Paciente;
            document.getElementById("principal_paciente").value = this.state.PacienteId;
            document.getElementById("principal_archivo_name").value = this.state.id_archivo;
            document.getElementById("principal_archivo").value = this.state.id_archivo;

            // Pre-populate 'diagnostico' (both code/ID and display name) from the parent 'archivo' record
            const parentArchivo = this.state.ListaTablas[0];
            if (parentArchivo) {
                const diagNameInput = document.getElementById("principal_diagnostico_name");
                if (diagNameInput && parentArchivo.diagnostico) {
                    diagNameInput.value = parentArchivo.diagnostico;
                    diagNameInput.dispatchEvent(new Event('change', { bubbles: true }));
                }

                const diagInput = document.getElementById("principal_diagnostico");
                if (diagInput) {
                    let codigo = '';
                    if (parentArchivo.diagnostico) {
                        const parts = parentArchivo.diagnostico.trim().split(/\s+/);
                        if (parts.length > 0) {
                            codigo = parts[parts.length - 1];
                        }
                    }
                    diagInput.value = codigo;
                    diagInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }

            // Default 'estado_ordenes' to '1' (Active) and set display name to 'ACTIVO'
            const statusInput = document.getElementById("principal_estado_ordenes");
            if (statusInput) {
                statusInput.value = "1";
                statusInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            const statusNameInput = document.getElementById("principal_estado_ordenes_name");
            if (statusNameInput) {
                statusNameInput.value = "ACTIVO";
                statusNameInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

        }, 300);
    }

    VerRegistros = (id, sub) => {
        const u = localStorage.getItem("idusuario");
        // Restauramos el URL correcto master/ver y usamos cache busting
        authAxios.get(`master/ver/${id}/${sub}?_t=${Date.now()}`)
            .then((datosRespuesta) => {
                const lista = datosRespuesta.data.result;
                const campos = datosRespuesta.data.modelo;

                this.setState({
                    idmenu: id,
                    iditem: sub,
                    ModeloFormularioPrincipal: campos,
                    showFormModalPrincipal: true
                });

                setTimeout(() => {
                    const subIdInput = document.getElementById("principal_sub_id");
                    if (subIdInput) {
                        subIdInput.value = sub;
                    }

                    campos.forEach((item) => {
                        if (item.trae_tabla != null) {
                            const nameElement = document.getElementById("principal_" + item.nombre_campo + "_name");
                            if (nameElement) {
                                nameElement.value = lista[item.nombre_campo + "_name"] || '';
                            }
                        }
                    });

                    campos.forEach((item) => {
                        if (item.tipo_dato === "blob") {
                            const imgElement = document.getElementById("imgd" + item.nombre_campo);
                            if (imgElement) {
                                imgElement.src = lista[item.nombre_campo] != null
                                    ? apiImage + lista[item.nombre_campo]
                                    : "https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg";
                            }

                            const tempElement = document.getElementById("temp" + item.nombre_campo);
                            if (tempElement) {
                                tempElement.value = lista[item.nombre_campo] || '';
                            }
                        } else if (item.tipo_dato === "checkbox") {
                            const inputElement = document.getElementById("principal_" + item.nombre_campo);
                            if (inputElement) {
                                inputElement.checked = (lista[item.nombre_campo] == "1" || lista[item.nombre_campo] == true);
                            }
                        } else if (item.tipo_dato === "radio") {
                            const inputElement = document.getElementById("principal_" + item.nombre_campo);
                            if (inputElement) {
                                inputElement.checked = (lista[item.nombre_campo] == "1" || lista[item.nombre_campo] == true);
                            }
                            const hid = document.getElementById(`hidden_principal_${item.nombre_campo}`);
                            if (hid) {
                                hid.value = (lista[item.nombre_campo] == "1" || lista[item.nombre_campo] == true) ? "1" : "0";
                            }
                        } else {
                            const inputElement = document.getElementById("principal_" + item.nombre_campo);
                            if (inputElement) {
                                inputElement.value = lista[item.nombre_campo] || '';
                            }
                        }
                    });
                }, 300);
            })
            .catch(error => {
                console.error("Error en VerRegistros:", error);
                this.mostrarAlerta('error', 'Error', 'No se pudieron cargar los datos');
            });
    }

    save = (formulario, idmenu) => {
        Swal.fire({
            title: 'Guardando...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        this.setState({ btnGuadar: 1 });

        const form = document.getElementById(formulario);
        const formData = new FormData(form);
        const u = localStorage.getItem("idusuario");

        authAxios.post(`master/registrar/${idmenu}/${u}`, formData)
            .then((datosRespuesta) => {
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    this.mostrarAlerta('success', 'ÃƒÂ‚Ã‚Â¡Registro exitoso!', datosRespuesta.data.msj);

                    document.getElementById(formulario).reset();
                    this.setState({ btnGuadar: 0 });

                    if (formulario === 'form_registro') {
                        this.ListarTabla(1);
                        const modal = document.getElementById('FormularioModal');
                        const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
                        if (bootstrapModal) {
                            bootstrapModal.hide();
                        }
                    } else if (formulario === 'form_registro_detalle') {
                        this.ListarTabla(1);
                        const modalDetalle = document.getElementById('FormularioModalDetalle');
                        const bootstrapModalDetalle = window.bootstrap.Modal.getInstance(modalDetalle);
                        if (bootstrapModalDetalle) {
                            bootstrapModalDetalle.hide();
                        }
                        this.limpiarFormularioDetalle();
                    }
                } else {
                    Swal.close();
                    this.mostrarAlerta('error', 'Error', datosRespuesta.data.msj);
                    this.setState({ btnGuadar: 0 });
                }
            })
            .catch(error => {
                console.error("Error al guardar:", error);
                Swal.close();
                this.mostrarAlerta('error', 'Error', 'No se pudo guardar el registro');
                this.setState({ btnGuadar: 0 });
            });
    }

    recargarDetallesOrdenPorDetalleId = (detalleId) => {
        authAxios.get(`ordenes/detalle/orden_detalle/id/${detalleId}`)
            .then((respuesta) => {
                const detalle = respuesta.data.detalle || respuesta.data;
                if (detalle && detalle.orden) {
                    const ordenId = detalle.orden;

                    var tabla = "orden_detalle";
                    var campo = "orden";

                    authAxios.get("ordenes/detalle/" + tabla + "/" + campo + "/" + ordenId)
                        .then((datosRespuesta) => {
                            const detallesActualizados = datosRespuesta.data.detalle || datosRespuesta.data;

                            this.setState(prevState => ({
                                detallesCargados: {
                                    ...prevState.detallesCargados,
                                    [ordenId]: Array.isArray(detallesActualizados) ? detallesActualizados : []
                                }
                            }));
                        })
                        .catch(error => {
                            console.error("Error al recargar detalles:", error);
                        });
                }
            })
            .catch(error => {
                console.error("Error al obtener detalle:", error);
                const idmenuRelaciones = 201;
                const iditem = localStorage.getItem('TablaId');
                this.VerRelaciones(idmenuRelaciones, iditem);
            });
    }

    handleCheckboxChange = (orderId) => {
        this.setState(prevState => ({
            selectedOrders: {
                ...prevState.selectedOrders,
                [orderId]: !prevState.selectedOrders[orderId]
            }
        }));
    }

    handleSelectAll = (orderIds, isChecked) => {
        const newSelectedOrders = { ...this.state.selectedOrders };
        orderIds.forEach(id => {
            newSelectedOrders[id] = isChecked;
        });
        this.setState({ selectedOrders: newSelectedOrders });
    }

    descargarSeleccionadosPDF = async () => {
        const selectedIds = Object.keys(this.state.selectedOrders).filter(id => this.state.selectedOrders[id]);

        if (selectedIds.length === 0) {
            Swal.fire('AtenciÃƒÂƒÃ‚Â³n', 'Debe seleccionar al menos una orden para imprimir', 'warning');
            return;
        }

        try {
            Swal.fire({
                title: 'Generando ImpresiÃƒÂƒÃ‚Â³n Seleccionada',
                text: `Procesando ${selectedIds.length} ÃƒÂƒÃ‚Â³rdenes...`,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await authAxios.post('/imprimir_seleccionados_base64', {
                ids: selectedIds
            });

            if (response.data.status) {
                const pdfWindow = window.open('', '_blank');
                if (pdfWindow) {
                    pdfWindow.document.write(`
                        <html>
                            <head>
                                <title>ImpresiÃƒÂƒÃ‚Â³n Seleccionada</title>
                                <style>
                                    body { margin: 0; padding: 0; background-color: #525659; display: flex; justify-content: center; }
                                    embed { width: 100vw; height: 100vh; border: none; }
                                </style>
                            </head>
                            <body>
                                <embed src="data:application/pdf;base64,${response.data.data}" type="application/pdf" />
                            </body>
                        </html>
                    `);
                    pdfWindow.document.close();
                }
                Swal.close();
            } else {
                Swal.fire('Error', response.data.message || 'Error al generar el PDF', 'error');
            }
        } catch (error) {
            console.error("Error al descargar PDF seleccionado:", error);
            Swal.fire('Error', 'No se pudo generar el documento PDF.', 'error');
        }
    }

    aplicarPaquete = (tipo) => {
        const idsP1 = [64, 70, 72, 105, 79, 80, 66]; // PAQUETE DE INSUMOS APLIC MED
        const idsP2 = [67, 75, 77, 78, 79, 113];     // PAQUETE DE CURACIONES
        const idsP3 = [56, 68, 69, 77, 78, 79, 80, 89]; // CAMBIO DE SONDA
        const ids = tipo === 1 ? idsP1 : (tipo === 2 ? idsP2 : idsP3);

        const nuevasCantidades = { ...this.state.cantidadesMasivo };
        ids.forEach(id => {
            nuevasCantidades[id] = 1;
        });

        this.setState({
            cantidadesMasivo: nuevasCantidades,
            idsPaqueteSeleccionado: ids // Filtrar por estos IDs
        });

        Swal.fire({
            icon: 'success',
            title: 'Paquete aplicado',
            text: 'Se han seleccionado y filtrado los productos del paquete.',
            timer: 1500,
            showConfirmButton: false
        });
    }

    resetFiltrosMasivo = () => {
        this.setState({
            busquedaMasivo: '',
            filtroTipoMasivo: '',
            idsPaqueteSeleccionado: null
        });
    }

    descargarPDFTablaHija = async (id, tabla) => {
        try {
            Swal.fire({
                title: 'Generando PDF',
                text: 'Por favor espere...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            let endpoint = 'imprimir_pdf_tabla_hija';
            if (tabla === 'formato_ingreso' || tabla === 'formato_evolucion') {
                endpoint = 'imprimir_pdf_formato';
            }
            const response = await authAxios.get(`${Url}${endpoint}/${id}/${tabla}`);

            if (response.data.status) {
                const pdfBase64 = response.data.data.pdf_base64;
                const fileName = response.data.data.file_name;

                const byteCharacters = atob(pdfBase64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
                Swal.close();
            } else {
                Swal.fire('Error', response.data.message || 'Error al generar el PDF', 'error');
            }
        } catch (error) {
            Swal.fire('Error', 'Error de red o de servidor', 'error');
            console.error(error);
        }
    };

    descargarPDF = async (idOrden) => {
        try {
            Swal.fire({
                title: 'Generando Historia ClÃƒÂƒÃ‚Â­nica',
                text: 'Por favor espere...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await authAxios.get(`/imprimir_pdf_base64/${idOrden}`);

            if (response.data.status) {
                const pdfWindow = window.open('', '_blank');
                if (pdfWindow) {
                    pdfWindow.document.write(`
                        <html>
                            <head>
                                <title>Historia ClÃƒÂƒÃ‚Â­nica #${idOrden}</title>
                                <style>
                                    body { 
                                        margin: 0; 
                                        padding: 0; 
                                        overflow: hidden; 
                                    }
                                    iframe { 
                                        width: 100%; 
                                        height: 100vh; 
                                        border: none; 
                                    }
                                </style>
                            </head>
                            <body>
                                <iframe 
                                    src="data:application/pdf;base64,${response.data.data}" 
                                    title="Historia ClÃƒÂƒÃ‚Â­nica #${idOrden}"
                                ></iframe>
                            </body>
                        </html>
                    `);
                }

                Swal.close();

                this.mostrarAlerta('success', 'PDF generado', 'La historia clÃƒÂƒÃ‚Â­nica se abrirÃƒÂƒÃ‚Â¡ en una nueva ventana');

                return true;
            } else {
                Swal.close();
                this.mostrarAlerta('error', 'Error', response.data.message || 'No se pudo generar el PDF');
                return false;
            }

        } catch (error) {
            console.error('Error generando PDF:', error);
            Swal.close();

            try {
                Swal.fire({
                    title: 'Intentando mÃƒÂƒÃ‚Â©todo alternativo...',
                    text: 'Por favor espere',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const directResponse = await authAxios.get(`/imprimir_pdf/${idOrden}`, {
                    responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([directResponse.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `historia_clinica_${idOrden}_${Date.now()}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();

                Swal.close();
                this.mostrarAlerta('success', 'Descarga iniciada', 'La historia clÃƒÂƒÃ‚Â­nica se estÃƒÂƒÃ‚Â¡ descargando');

                return true;
            } catch (fallbackError) {
                console.error('Error en fallback:', fallbackError);
                Swal.close();
                this.mostrarAlerta('error', 'Error', 'No se pudo generar la historia clÃƒÂƒÃ‚Â­nica');
                return false;
            }
        }
    }
    descargarConsentimientoPDF = async (idOrden) => {
        try {
            Swal.fire({
                title: 'Generando Pdf del consentimiento',
                text: 'Por favor espere...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await authAxios.get(`/ordenes/consentimiento-pdf-base64/${idOrden}`);

            if (response.data.status) {
                const pdfWindow = window.open('', '_blank');
                if (pdfWindow) {
                    pdfWindow.document.write(`
                        <html>
                            <head>
                                <title>Consentimiento #${idOrden}</title>
                                <style>
                                    body { 
                                        margin: 0; 
                                        padding: 0; 
                                        overflow: hidden; 
                                    }
                                    iframe { 
                                        width: 100%; 
                                        height: 100vh; 
                                        border: none; 
                                    }
                                </style>
                            </head>
                            <body>
                                <iframe 
                                    src="data:application/pdf;base64,${response.data.data}" 
                                    title="Consentimiento #${idOrden}"
                                ></iframe>
                            </body>
                        </html>
                    `);
                }

                Swal.close();

                this.mostrarAlerta('success', 'PDF generado', 'La historia clÃƒÂƒÃ‚Â­nica se abrirÃƒÂƒÃ‚Â¡ en una nueva ventana');

                return true;
            } else {
                Swal.close();
                this.mostrarAlerta('error', 'Error', response.data.message || 'No se pudo generar el PDF');
                return false;
            }

        } catch (error) {
            console.error('Error generando PDF:', error);
            Swal.close();

            try {
                Swal.fire({
                    title: 'Intentando mÃƒÂƒÃ‚Â©todo alternativo...',
                    text: 'Por favor espere',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const directResponse = await authAxios.get(`/ordenes/consentimiento-pdf/${idOrden}`, {
                    responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([directResponse.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Consentimiento_${idOrden}_${Date.now()}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();

                Swal.close();
                this.mostrarAlerta('success', 'Descarga iniciada', 'La historia clÃƒÂƒÃ‚Â­nica se estÃƒÂƒÃ‚Â¡ descargando');

                return true;
            } catch (fallbackError) {
                console.error('Error en fallback:', fallbackError);
                Swal.close();
                this.mostrarAlerta('error', 'Error', 'No se pudo generar la historia clÃƒÂƒÃ‚Â­nica');
                return false;
            }
        }
    }
    borrarRegistros = (idm, id) => {
        const u = localStorage.getItem("idusuario");

        Swal.fire({
            title: "¿Está seguro de eliminar este registro?",
            text: "Esta acción no se puede deshacer",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return authAxios.get(`master/borrar/${idm}/${id}/${u}`)
                    .then(response => {
                        if (response.data.Status === false) {
                            throw new Error(response.data.msj || 'Error al eliminar el registro');
                        }
                        return response.data;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            error.response?.data?.msj || error.message || 'Error en la peticiÃƒÂƒÃ‚Â³n'
                        );
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                this.mostrarAlerta('success', 'ÃƒÂ‚Ã‚Â¡Eliminado!',
                    result.value?.msj || 'El registro ha sido eliminado correctamente'
                ).then(() => {
                    this.ListarTabla(1);
                });
            }
        }).catch(error => {
            console.error("Error al eliminar:", error);
            this.mostrarAlerta('error', 'Error', 'No se pudo eliminar el registro');
        });
    }

    abrirEditarPaciente = (pacienteId) => {
        const pId = pacienteId || this.state.PacienteId;
        if (!pId) {
            this.mostrarAlerta('warning', 'AtenciÃƒÂ³n', 'No se encontrÃƒÂ³ el ID del paciente para editar');
            return;
        }
        this.VerRegistros(168, pId);
    }

    renderTablasHijasPorOrden = (ordenId, permisos) => {
        let tablasOrdenadas = this.ordenarTablasHijas(this.state.tablasHijas);
        
        const orden = this.state.ListaOrdenes.find(o => o.id === ordenId);
        let tablasPermitidas = [];
        if (orden) {
            let tc_int = parseInt(orden.tipo_consulta);
            if (orden.tipo_consulta && typeof orden.tipo_consulta === 'string' && isNaN(tc_int)) {
                const val = orden.tipo_consulta.toLowerCase();
                if (val.includes('ingreso') || val.includes('valoracion') || val.includes('evolucion') || val.includes('medico') || val.includes('mdico') || val.includes('seguimiento') || val.includes('medicina')) { tablasPermitidas = (parseInt(orden.cantidad) > 1) ? ['formato_ingreso', 'formato_evolucion'] : ['formato_ingreso']; } else if (val.includes('evolucion general') || val.includes('evolucin general')) { tablasPermitidas = ['evolucion_general']; }
                else if (val.includes('turno') && val.includes('enfermer')) tablasPermitidas = ['turno_enfermeria'];
                else if (val.includes('enfermer')) tablasPermitidas = ['enfermeria'];
                else if (val.includes('procedimiento')) tablasPermitidas = ['procedimientos'];
                else if (val.includes('fisioterapia')) tablasPermitidas = ['fisioterapia_inicial', 'fisioterapia_diaria'];
                else if (val.includes('fonoaudiologia') || val.includes('fonoaudiologÃ­a')) tablasPermitidas = ['terapia_fonoaudiologia', 'terapia_fonoaudiologia_diaria'];
                else if (val.includes('ocupacional')) tablasPermitidas = ['terapia_ocupacional', 'terapia_ocupacional_diaria'];
                else if (val.includes('nutricion') || val.includes('nutriciÃ³n')) tablasPermitidas = ['formato_nutricion'];
                else if (val.includes('psicologia') || val.includes('psicologÃ­a')) tablasPermitidas = ['formato_psicologia'];
            } else if (orden.tipo_consulta) {
                const tipo_consulta = parseInt(orden.tipo_consulta);
                if (tipo_consulta === 1 || tipo_consulta === 2) { tablasPermitidas = (parseInt(orden.cantidad) > 1) ? ['formato_ingreso', 'formato_evolucion'] : ['formato_ingreso']; }
                else if (tipo_consulta === 3) tablasPermitidas = ['enfermeria'];
                else if (tipo_consulta === 4) tablasPermitidas = ['procedimientos'];
                else if (tipo_consulta === 5) tablasPermitidas = ['fisioterapia_inicial', 'fisioterapia_diaria', 'formato_inicial_fisioterapia'];
                else if (tipo_consulta === 6) tablasPermitidas = ['terapia_fonoaudiologia', 'terapia_fonoaudiologia_diaria'];
                else if (tipo_consulta === 7) tablasPermitidas = ['terapia_ocupacional', 'terapia_ocupacional_diaria'];
                else if (tipo_consulta === 8) tablasPermitidas = ['evolucion_general'];
            }
            
            // Tablas que siempre deben mostrarse (se removiÃ³ orden_detalle)
            const siempreVisibles = ['prescripcion', 'evolucion', 'remision', 'incapacidad', 'productos_asignados', 'laboratorios'];
            
            tablasOrdenadas = tablasOrdenadas.filter(tablaHija => {
                const nombre = tablaHija.tablaforanea;
                return siempreVisibles.includes(nombre) || tablasPermitidas.includes(nombre);
            });
            
            // Garantizar que las tablas existan
            tablasPermitidas.forEach(nombreTabla => {
                if (!tablasOrdenadas.some(t => t.tablaforanea === nombreTabla)) {
                    tablasOrdenadas.push({
                        tablaforanea: nombreTabla,
                        relacion_fk: 'orden_interna', // defecto
                        alias_tabla: nombreTabla.replace(/_/g, ' ').toUpperCase()
                    });
                }
            });
        }
        return (
            <tr key={`tablas-hijas-${ordenId}`} className="table-secondary">
                <td></td>
                <td colSpan="12">
                    <div className="p-3">
                        <h6 className="mb-3">
                            <FontAwesomeIcon icon={faTable} className="me-2" />
                            Tablas relacionadas a la orden #{ordenId}:
                        </h6>
                        {tablasOrdenadas.map((tablaHija, idx) =>
                            this.renderTablaHija(tablaHija, ordenId, idx, permisos)
                        )}
                    </div>
                </td>
            </tr>
        );
    };

    renderRelaciones = () => {
        const {
            ListaRelaciones,
            ListaOrdenes,
            load,
            detallesExpandidos,
            cargandoDetalle,
            permisos
        } = this.state;

        if (!ListaRelaciones || !Array.isArray(ListaRelaciones) || ListaRelaciones.length === 0) {
            return (
                <div className="alert alert-info">
                    No hay relaciones disponibles
                </div>
            );
        }

        return ListaRelaciones.map((encabezado, indexRelacion) => {
            const ordenesRelacionadas = Array.isArray(ListaOrdenes) ? ListaOrdenes : [];

            return (
                <div className="mb-4" key={indexRelacion}>
                    <div className="d-flex align-items-center mb-2">
                        <h4 className="mb-0">
                            <span className="badge bg-success p-2">
                                {encabezado.alias_tabla || encabezado.nombre_tabla || encabezado.tablaforanea || 'RelaciÃƒÂ³n'}
                            </span>
                        </h4>
                        <span className="badge bg-secondary ms-2">
                            {ordenesRelacionadas.length} registros
                        </span>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-hover table-condensed table-sm table-bordered">
                            <thead className="table-light">
                                <tr>
                                    <th className="align-middle" style={{ width: '40px' }}>
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                const allIds = ordenesRelacionadas.map(o => o.id);
                                                this.handleSelectAll(allIds, e.target.checked);
                                            }}
                                            checked={ordenesRelacionadas.length > 0 && ordenesRelacionadas.every(o => this.state.selectedOrders[o.id])}
                                        />
                                    </th>
                                    <th className="align-middle" style={{ width: '50px' }}>Detalles</th>
                                    <th className="align-middle">ID</th>
                                    <th className="align-middle">Orden Externa</th>
                                    <th className="align-middle">AtenciÃƒÂ³n</th>
                                    <th className="align-middle">Cantidad</th>
                                    <th className="align-middle">Completadas</th>
                                
                                    <th className="align-middle">Paquete</th>
                                    <th className="align-middle">Profesional</th>
                                    <th className="align-middle">Fecha Ingreso</th>

                                    <th className="align-middle">DiagnÃƒÂ³stico</th>
                                    {(permisos.editar === 1 || permisos.eliminar === 1) && (
                                        <th className="align-middle">Acciones</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {load}
                                {ordenesRelacionadas.length > 0 ? (
                                    ordenesRelacionadas.map((item) => {
                                        const estaExpandido = detallesExpandidos[item.id];
                                        const estaCargando = cargandoDetalle[item.id];

                                        const cantidad = parseInt(item.cantidad) || 0;
                                        const completadas = parseInt(item.orden_completada) || 0;
                                        const porcentaje = cantidad > 0 ? Math.round((completadas / cantidad) * 100) : 0;

                                        const getProgressBarColor = (porcentaje) => {
                                            if (porcentaje >= 100) return 'bg-success';
                                            if (porcentaje >= 70) return 'bg-info';
                                            if (porcentaje >= 40) return 'bg-warning';
                                            return 'bg-danger';
                                        };

                                        const estadoActual = item.estado_ordenes_id !== undefined ? item.estado_ordenes_id : item.estado_ordenes;
                                        const esInactiva = estadoActual != 1 && estadoActual !== '1' && String(estadoActual).toUpperCase() !== 'ACTIVO';
                                        let trClassName = estaExpandido ? 'table-active' : '';
                                        if (esInactiva) {
                                            trClassName = 'table-danger text-muted';
                                        }

                                        return (
                                            <React.Fragment key={item.id}>
                                                <tr className={trClassName}>
                                                    <td className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={this.state.selectedOrders[item.id] || false}
                                                            onChange={() => this.handleCheckboxChange(item.id)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <div className="btn-group" role="group">
                                                            {String(localStorage.getItem("rol") || localStorage.getItem("id_rol")) !== "7" && (
                                                                <button
                                                                    type="button"
                                                                    className={`btn btn-${estaExpandido ? 'warning' : 'secondary'} btn-xs`}
                                                                    onClick={() => this.VerDetalle(item.id, item.id)}
                                                                    disabled={estaCargando}
                                                                    title={estaExpandido ? "Ocultar detalles" : "Ver detalles"}
                                                                    style={{ width: '32px', height: '32px' }}
                                                                >
                                                                    {estaCargando ? (
                                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                    ) : (
                                                                        <FontAwesomeIcon icon={estaExpandido ? faEyeSlash : faEye} />
                                                                    )}
                                                                </button>
                                                            )}
                                                            <button
                                                                type="button"
                                                                className="btn btn-success btn-xs"
                                                                onClick={() => this.descargarPDF(item.id)}
                                                                title="Descargar Historia ClÃƒÂ­nica"
                                                            >
                                                                <FontAwesomeIcon icon={faPrint} />
                                                            </button>
                                                            {item.consentimiento != null ?
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-xs"
                                                                    onClick={() => this.descargarConsentimientoPDF(item.id)}
                                                                    title="Descargar Consentimiento Informado"
                                                                >
                                                                    <FontAwesomeIcon icon={faPrint} />
                                                                </button> : ''}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {item.id}
                                                        {esInactiva && <span className="badge bg-danger ms-2">Anulada</span>}
                                                    </td>
                                                    <td>{item.orden_externa || '-'}</td>
                                                    <td>{item.atencion || '-'}</td>
                                                    <td className="text-center">{item.cantidad || '-'}</td>
                                                   
                                                    <td className="text-center" style={{ minWidth: '120px' }}>
                                                        {item.porcentaje > 0 ? (
                                                            <div className="d-flex align-items-center">
                                                                <div className="progress flex-grow-1" style={{ height: '20px' }}>
                                                                    <div
                                                                        className={`progress-bar ${getProgressBarColor(item.porcentaje)}`}
                                                                        role="progressbar"
                                                                        style={{ width: `${item.porcentaje}%` }}
                                                                        aria-valuenow={item.porcentaje}
                                                                        aria-valuemin="0"
                                                                        aria-valuemax="100"
                                                                    >
                                                                        {item.porcentaje}%
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <span className="text-muted">-</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${item.paquete === 'SI' ? 'bg-success' : 'bg-secondary'}`}>
                                                            {item.paquete || 'NO'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {item.asignado || item.profesional || '-'}
                                                        {item.porcentaje < 100 && String(localStorage.getItem("rol") || localStorage.getItem("id_rol")) !== "7" && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-xs ms-2"
                                                                title="Cambiar Profesional"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#ModalBusqueda"
                                                                onClick={() => this.abrirModalCambioProfesional(item.id)}
                                                            >
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </button>
                                                        )}
                                                    </td>
                                                    <td>{item.fecha_inicial || '-'}</td>

                                                    <td>
                                                        <small>{item.diagnostico || '-'}</small>
                                                    </td>

                                                    {(permisos.editar === 1) && (
                                                        <td>
                                                            <div className="btn-group" role="group">
                                                                {permisos.editar === 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-xs"
                                                                        onClick={() => this.VerRegistros(201, item.id)}
                                                                        title="Editar"
                                                                    >
                                                                        <FontAwesomeIcon icon={faEdit} />
                                                                    </button>
                                                                )}


                                                                {porcentaje < 100 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-xs"
                                                                        onClick={() => this.cambiarProfesional(item)}
                                                                        title="Cambiar Profesional"
                                                                    >
                                                                        <FontAwesomeIcon icon={faExchangeAlt} />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    )}
                                                    {permisos.eliminar === 1 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-xs"
                                                            onClick={() => this.borrarRegistros(201, item.id)}
                                                            title="Eliminar"
                                                        >
                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                        </button>
                                                    )}
                                                </tr>

                                                {estaExpandido && this.renderTablasHijasPorOrden(item.id, permisos)}
                                            </React.Fragment>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={(permisos.editar === 1 || permisos.eliminar === 1) ? "14" : "13"} className="text-center text-muted">
                                            No hay ÃƒÂ³rdenes en esta relaciÃƒÂ³n
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        });
    };

    consultarIA = async () => {
        const valoracion = document.getElementById("detalle_valoracion")?.value;
        const idRegistro = this.state.idRegistroDetalle;

        if (!valoracion || valoracion.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'AtenciÃƒÂ³n',
                text: 'El campo valoraciÃƒÂ³n estÃƒÂ¡ vacÃƒÂ­o',
                confirmButtonText: 'Entendido'
            });
            return;
        }

        Swal.fire({
            title: 'Consultando a la IA...',
            text: 'Por favor espere',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const formData = new FormData();
            formData.append('valoracion', valoracion);
            if (idRegistro) {
                formData.append('id', idRegistro);
            }

            const response = await fetch("http://127.0.0.1:8000/api/ia/consulta", {
                method: "POST",
                headers: {
                    "Accept": "application/json"
                },
                body: formData
            });

            const data = await response.json();
            Swal.close();

            if (data.status && data.prediccion) {
                Swal.fire({
                    title: 'Respuesta de la IA',
                    html: `<div style="text-align: left; max-height: 300px; overflow-y: auto; padding: 10px; font-size: 14px;">${data.prediccion.replace(/\n/g, '<br/>')}</div><br/><b>Ã‚Â¿Desea colocar esta respuesta en el campo tratamiento?</b>`,
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'SÃƒÂ­, colocar',
                    cancelButtonText: 'Cancelar',
                    width: '600px'
                }).then((result) => {
                    if (result.isConfirmed) {
                        const tratamientoInput = document.getElementById("detalle_tratamiento");
                        if (tratamientoInput) {
                            tratamientoInput.value = data.prediccion;
                        } else {
                            Swal.fire('Error', 'No se encontrÃƒÂ³ el campo tratamiento en el formulario', 'error');
                        }
                    }
                });
            } else {
                Swal.fire('Error', 'No se pudo obtener una respuesta vÃƒÂ¡lida de la IA', 'error');
            }
        } catch (error) {
            Swal.close();
            console.error("Error IA:", error);
            Swal.fire('Error', 'Error al conectar con la IA', 'error');
        }
    }
    descargarPDFMasivo = async (idArchivo) => {
        try {
            Swal.fire({
                title: 'Generando ImpresiÃƒÂ³n Masiva',
                text: 'Por favor espere, procesando todas las ÃƒÂ³rdenes...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await authAxios.get(`/imprimir_masivo_base64/${idArchivo}`);

            if (response.data.status) {
                const pdfWindow = window.open('', '_blank');
                if (pdfWindow) {
                    pdfWindow.document.write(`
                        <html>
                            <head>
                                <title>ImpresiÃƒÂ³n Masiva Archivo #${idArchivo}</title>
                                <style>
                                    body { 
                                        margin: 0; 
                                        padding: 0; 
                                        background-color: #525659; 
                                        display: flex; 
                                        justify-content: center; 
                                    }
                                    embed { 
                                        width: 100vw; 
                                        height: 100vh; 
                                        border: none; 
                                    }
                                </style>
                            </head>
                            <body>
                                <embed src="data:application/pdf;base64,${response.data.data}" type="application/pdf" />
                            </body>
                        </html>
                    `);
                    pdfWindow.document.close();
                } else {
                    Swal.fire('Error', 'Por favor permita las ventanas emergentes (pop-ups) para ver el PDF.', 'error');
                }
                Swal.close();
            } else {
                Swal.fire('Error', response.data.message || 'Error al generar el PDF masivo', 'error');
            }
        } catch (error) {
            console.error("Error al descargar PDF masivo:", error);
            Swal.fire('Error', 'No se pudo generar el documento PDF masivo.', 'error');
        }
    }

    componentDidMount() {
        this.ListarTabla(1);
    }

    renderFieldPrincipal(row, key) {
        if (row.nombre_campo === "id") {
            return null;
        }
        return (
            <div
                className={`col-md-${row.columna} ${row.alineacion}`}
                id={`principal_${row.nombre_campo}-div`}
                key={key}
            >
                {row.tipo_dato === "blob" ? (
                    <div className="gallery my-gallery card-body row">
                        <figure className="col-xl-12 col-md-12 col-12">
                            <a href="#" data-size="1600x950">
                                <img
                                    className="img-thumbnail"
                                    id={"imgd" + row.nombre_campo}
                                    src="https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg"
                                    alt={row.nombre_titulo}
                                    style={{ maxHeight: '150px' }}
                                />
                            </a>
                            <figcaption>
                                {row.orden}.{row.nombre_titulo}
                            </figcaption>
                        </figure>
                    </div>
                ) : (
                    <label htmlFor={`principal_${row.nombre_titulo}`}>
                        {row.orden}.{row.nombre_titulo}{" "}
                        {row.obligatorio === "1" ? <span className="text-danger">*</span> : ""}
                    </label>
                )}

                {row.trae_tabla === null ? (
                    row.tipo_dato === "text" ? (
                        <textarea
                            className="form-control form-control-sm"
                            readOnly={row.campo_editable !== "Si"}
                            name={row.nombre_campo}
                            id={"principal_" + row.nombre_campo}
                            rows="3"
                        ></textarea>
                    ) : row.tipo_dato === "radio" ? (
                        <div className="form-check" style={{ marginTop: '5px' }}>
                            <input
                                type="hidden"
                                name={row.nombre_campo}
                                id={`hidden_principal_${row.nombre_campo}`}
                                value="0"
                            />
                            <input
                                className="form-check-input"
                                type="radio"
                                name={row.nombre_name}
                                id={"principal_" + row.nombre_campo}
                                disabled={row.campo_editable !== "Si"}
                                onChange={e => {
                                    this.state.ModeloFormularioPrincipal.forEach(c => {
                                        if (c.nombre_name === row.nombre_name) {
                                            const hid = document.getElementById(`hidden_principal_${c.nombre_campo}`);
                                            if (hid) hid.value = "0";
                                        }
                                    });
                                    const currentHid = document.getElementById(`hidden_principal_${row.nombre_campo}`);
                                    if (currentHid) currentHid.value = "1";
                                }}
                            />
                        </div>
                    ) : row.tipo_dato === "blob" ? (
                        <input
                            type="file"
                            className="form-control form-control-sm mt-2"
                            name={row.nombre_campo}
                            id={"principal_" + row.nombre_campo}
                            disabled={row.campo_editable !== "Si"}
                        />
                    ) : (
                        <input
                            className={row.tipo_dato === "checkbox" ? "form-check-input mt-2" : "form-control form-control-sm"}
                            readOnly={row.campo_editable !== "Si"}
                            type={
                                row.tipo_dato === "int" ? "number" :
                                    row.tipo_dato === "date" ? "date" :
                                        row.tipo_dato === "time" ? "time" :
                                            row.tipo_dato === "datetime" ? "datetime-local" :
                                                row.tipo_dato === "checkbox" ? "checkbox" :
                                                    "text"
                            }
                            name={row.nombre_campo}
                            id={"principal_" + row.nombre_campo}
                        />
                    )
                ) : (
                    <>
                        <input
                            type="hidden"
                            name={row.nombre_campo}
                            id={"principal_" + row.nombre_campo}
                        />
                        <div className="input-group mb-3">
                            <input
                                className="form-control form-control-sm"
                                readOnly
                                type="text"
                                name={row.nombre_campo + "_name"}
                                id={"principal_" + row.nombre_campo + "_name"}
                            />
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() =>
                                    this.Buscar(
                                        row.trae_tabla,
                                        row.trae_value,
                                        row.trae_campo,
                                        row.nombre_campo,
                                        row.trae_opcional
                                    )
                                }
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#ModalSelect"
                                disabled={row.campo_editable !== "Si"}
                            >
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        </div>
                    </>
                )}
            </div>
        );
    }

    renderTabFieldsPrincipal(pestana) {
        const fields = this.state.ModeloFormularioPrincipal.filter(r => (r.pestana || 'General') === (pestana || 'General'));
        const result = [];
        let currentGroup = null;
        let currentGroupFields = [];

        const flushGroup = (key) => {
            if (currentGroupFields.length > 0) {
                const groupName = currentGroup;
                const fieldsToRender = [...currentGroupFields];
                result.push(
                    <div className="col-12" key={`group-wrapper-p-${groupName}-${key}`} style={{ marginBottom: "15px" }}>
                        <fieldset style={{
                            border: "2px solid #000000",
                            borderRadius: "8px",
                            padding: "20px 20px 10px 20px",
                            position: "relative",
                            marginTop: "15px"
                        }}>
                            <legend style={{
                                position: "absolute",
                                top: "-12px",
                                left: "20px",
                                background: "#ffffff",
                                padding: "0 10px",
                                fontSize: "14px",
                                fontWeight: "bold",
                                width: "auto",
                                float: "none",
                                color: "#333333"
                            }}>
                                {groupName}
                            </legend>
                            <div className="row">
                                {fieldsToRender.map((row, idx) => this.renderFieldPrincipal(row, `${key}-${idx}`))}
                            </div>
                        </fieldset>
                    </div>
                );
                currentGroupFields = [];
            }
        };

        fields.forEach((row, i) => {
            if (row.nombre_campo === "id") {
                return;
            }
            const hasGroup = row.grupo && row.grupo.trim() !== "";
            if (hasGroup) {
                if (currentGroup && currentGroup !== row.grupo) {
                    flushGroup(i);
                }
                currentGroup = row.grupo;
                currentGroupFields.push(row);
            } else {
                flushGroup(i);
                currentGroup = null;
                result.push(this.renderFieldPrincipal(row, i));
            }
        });

        flushGroup(fields.length);
        return result;
    }

    renderFieldDetalleOrder(row, key) {
        if (row.nombre_campo === "id") {
            return null;
        }
        return (
            <div
                className={`col-md-${row.columna} ${row.alineacion}`}
                id={`detalle_${row.nombre_campo}-div`}
                key={key}
            >
                {row.tipo_dato === "blob" ? (
                    <div className="gallery my-gallery card-body row">
                        <figure className="col-xl-12 col-md-12 col-12">
                            <a href="#" data-size="1600x950">
                                <img
                                    className="img-thumbnail"
                                    id={"detalle_img_" + row.nombre_campo}
                                    src="https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg"
                                    alt={row.nombre_titulo}
                                    style={{ maxHeight: '150px' }}
                                />
                            </a>
                            <figcaption>
                                {row.orden}.{row.nombre_titulo}
                            </figcaption>
                        </figure>
                    </div>
                ) : (
                    <label htmlFor={`detalle_${row.nombre_titulo}`}>
                        {row.orden}.{row.nombre_titulo}{" "}
                        {row.obligatorio === "1" ? <span className="text-danger">*</span> : ""}
                    </label>
                )}

                {row.trae_tabla === null ? (
                    row.tipo_dato === "text" ? (
                        <>
                            <textarea
                                className="form-control form-control-sm"
                                readOnly={row.campo_editable !== "Si"}
                                name={row.nombre_campo}
                                id={"detalle_" + row.nombre_campo}
                                rows="3"
                            ></textarea>
                            {this.state.TablaRelacionActual === 'orden_detalle' && row.nombre_campo === 'valoracion' && (
                                <button
                                    type="button"
                                    className="btn btn-info btn-sm mt-2 text-white"
                                    onClick={this.consultarIA}
                                >
                                    <FontAwesomeIcon icon={faSearch} className="me-1" /> Preguntar a la IA
                                </button>
                            )}
                        </>
                    ) : row.tipo_dato === "radio" ? (
                        <div className="form-check" style={{ marginTop: '5px' }}>
                            <input
                                type="hidden"
                                name={row.nombre_campo}
                                id={`hidden_detalle_${row.nombre_campo}`}
                                value="0"
                            />
                            <input
                                className="form-check-input"
                                type="radio"
                                name={row.nombre_name}
                                id={"detalle_" + row.nombre_campo}
                                disabled={row.campo_editable !== "Si"}
                                onChange={e => {
                                    // Encontrar todos los inputs ocultos del mismo grupo y poner a 0, luego el actual a 1
                                    this.state.ModeloFormularioDetalle.forEach(c => {
                                        if (c.nombre_name === row.nombre_name) {
                                            const hid = document.getElementById(`hidden_detalle_${c.nombre_campo}`);
                                            if (hid) hid.value = "0";
                                        }
                                    });
                                    const currentHid = document.getElementById(`hidden_detalle_${row.nombre_campo}`);
                                    if (currentHid) currentHid.value = "1";
                                }}
                            />
                        </div>
                    ) : row.tipo_dato === "blob" ? (
                        <input
                            type="file"
                            className="form-control form-control-sm mt-2"
                            name={row.nombre_campo}
                            id={"detalle_" + row.nombre_campo}
                            disabled={row.campo_editable !== "Si"}
                        />
                    ) : (
                        <input
                            className={row.tipo_dato === "checkbox" ? "form-check-input mt-2" : "form-control form-control-sm"}
                            readOnly={row.campo_editable !== "Si"}
                            type={
                                row.tipo_dato === "int" ? "number" :
                                    row.tipo_dato === "date" ? "date" :
                                        row.tipo_dato === "time" ? "time" :
                                            row.tipo_dato === "datetime" ? "datetime-local" :
                                                row.tipo_dato === "checkbox" ? "checkbox" :
                                                    "text"
                            }
                            name={row.nombre_campo}
                            id={"detalle_" + row.nombre_campo}
                            defaultValue={this.state.idRegistroDetalle ? this.state.DataPrincipal?.[row.nombre_campo] : ''}
                            onBlur={() => {
                                if (row.control_funcion != null) {
                                    this.FuncionGenerica(row.nombre_campo, row.control_funcion);
                                }
                            }}
                        />
                    )
                ) : (
                    <>
                        <input
                            type="hidden"
                            name={row.nombre_campo}
                            id={"detalle_" + row.nombre_campo}
                        />
                        <div className="input-group mb-3">
                            <input
                                className="form-control form-control-sm"
                                readOnly
                                type="text"
                                name={row.nombre_campo + "_name"}
                                id={"detalle_" + row.nombre_campo + "_name"}
                            />
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() =>
                                    this.BuscarDetalle(
                                        row.trae_tabla,
                                        row.trae_value,
                                        row.trae_campo,
                                        row.nombre_campo,
                                        row.trae_opcional
                                    )
                                }
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#ModalSelect"
                                disabled={row.campo_editable !== "Si"}
                            >
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        </div>
                    </>
                )}
            </div>
        );
    }

    renderTabFieldsDetalleOrder(pestana) {
        const fields = this.state.ModeloFormularioDetalle.filter(r => (r.pestana || 'General') === (pestana || 'General'));
        const result = [];
        let currentGroup = null;
        let currentGroupFields = [];

        const flushGroup = (key) => {
            if (currentGroupFields.length > 0) {
                const groupName = currentGroup;
                const fieldsToRender = [...currentGroupFields];
                result.push(
                    <div className="col-12" key={`group-wrapper-d-${groupName}-${key}`} style={{ marginBottom: "15px" }}>
                        <fieldset style={{
                            border: "2px solid #000000",
                            borderRadius: "8px",
                            padding: "20px 20px 10px 20px",
                            position: "relative",
                            marginTop: "15px"
                        }}>
                            <legend style={{
                                position: "absolute",
                                top: "-12px",
                                left: "20px",
                                background: "#ffffff",
                                padding: "0 10px",
                                fontSize: "14px",
                                fontWeight: "bold",
                                width: "auto",
                                float: "none",
                                color: "#333333"
                            }}>
                                {groupName}
                            </legend>
                            <div className="row">
                                {fieldsToRender.map((row, idx) => this.renderFieldDetalleOrder(row, `${key}-${idx}`))}
                            </div>
                        </fieldset>
                    </div>
                );
                currentGroupFields = [];
            }
        };

        fields.forEach((row, i) => {
            if (row.nombre_campo === "id") {
                return;
            }
            const hasGroup = row.grupo && row.grupo.trim() !== "";
            if (hasGroup) {
                if (currentGroup && currentGroup !== row.grupo) {
                    flushGroup(i);
                }
                currentGroup = row.grupo;
                currentGroupFields.push(row);
            } else {
                flushGroup(i);
                currentGroup = null;
                result.push(this.renderFieldDetalleOrder(row, i));
            }
        });

        flushGroup(fields.length);
        return result;
    }

    render() {
        const {
            load, ListaTablas, isLoadingOpen, TablaModal, btnGuadar, searchTerm,
            ModeloFormularioPrincipal, ModeloFormularioDetalle, idmenu, permisos,
            showFormModal, showFormModalPrincipal, btnGuadarDetalle, btnGuadarPrincipal,
            modalActivo, iditem, TablaRelacionActual
        } = this.state;

        const userRol = String(localStorage.getItem("rol") || localStorage.getItem("id_rol"));
        if (userRol === "7") {
            permisos.editar = 0; permisos.eliminar = 0; permisos.registrar = 0;
        }

        const TabsPrincipal = ModeloFormularioPrincipal.filter((v, i, a) => a.findIndex(t => (t.pestana === v.pestana)) === i);
        const TabsDetalle = ModeloFormularioDetalle.filter((v, i, a) => a.findIndex(t => (t.pestana === v.pestana)) === i);
        const limiteModal = searchTerm.trim() === '' ? 200 : 500;
        const TablaModalVisible = Array.isArray(TablaModal) ? TablaModal.slice(0, limiteModal) : [];
        const totalModal = Array.isArray(TablaModal) ? TablaModal.length : 0;
        const totalModalOriginal = Array.isArray(this.state.TablaModalOriginal) ? this.state.TablaModalOriginal.length : 0;

        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-danger btn-sm" to={`${process.env.PUBLIC_URL}/pages/${String(localStorage.getItem('rol') || localStorage.getItem('id_rol')) === '7' ? 'maestro_ordenes_sura' : 'maestro_ordenes'}/${tema}`}>
                                <FontAwesomeIcon icon={faBackward} />&nbsp;&nbsp;Regresar
                            </Link>
                            &nbsp;

                            {permisos.registrar === 1 && (
                                <button
                                    className="btn btn-success btn-sm"
                                    onClick={() => this.limpiarformulario(201)}
                                >
                                    <FontAwesomeIcon icon={faPlus} /> Agregar Orden Interna
                                </button>
                            )}
                        </div>

                        <div className="card-body">
                            <h4><span id="titulo"></span></h4>
                            <hr />

                            <div className="row mb-3">
                                <div className="col-xl-3">
                                    <input
                                        style={{ textTransform: 'uppercase' }}
                                        type="text"
                                        id="bus_orden_externa"
                                        name="bus_orden_externa"
                                        placeholder="Buscar orden externa..."
                                        className="form-control form-control-sm"
                                    />
                                </div>
                                <div className="col-xl-3">
                                    <button
                                        id="bt"
                                        name="bt"
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => this.ListarTabla(1)}
                                    >
                                        <FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Buscar Orden externa
                                    </button>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="align-middle">ARCHIVO</th>
                                            <th className="align-middle">ORDEN EXTERNA</th>
                                            <th className="align-middle">NOMBRE DEL PACIENTE</th>
                                            <th className="align-middle">DOCUMENTOS</th>
                                            <th className="align-middle">DOCUMENTOS</th>
                                            <th className="align-middle">COPAGO</th>
                                            <th className="align-middle">QUIEN COBRA</th>
                                            <th className="align-middle">ESTADO %</th>
                                            <th className="align-middle">FECHA DE REGISTRO</th>
                                            <th className="align-middle">ACCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {ListaTablas && ListaTablas.length > 0 ? (
                                            ListaTablas.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.id}</td>
                                                    <td>{item.autorizacion || item.orden_externa || '-'}</td>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <span>{item.paciente || '-'}</span>
                                                            {userRol !== "7" && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-warning btn-xs"
                                                                    title="Editar datos del paciente"
                                                                    onClick={() => this.abrirEditarPaciente(item.paciente_id || item.paciente_value || item.paciente_raw || this.state.PacienteId)}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} className="me-1" />
                                                                    Editar
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {item.pdf && item.pdf !== '-' ? (
                                                            <a href={apiImage + item.pdf} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-info">
                                                                Ver PDF
                                                            </a>
                                                        ) : '-'}
                                                    </td>
                                                    <td>
                                                        {item.pdf2 && item.pdf2 !== '-' ? (
                                                            <a href={apiImage + item.pdf2} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-info">
                                                                Ver PDF
                                                            </a>
                                                        ) : '-'}
                                                    </td>
                                                    <td>{item.copago_total || item.copago_total || '0'}</td>
                                                    <td>
                                                        {item.quien_cobra ? (
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span>{item.quien_cobra}</span>
                                                                {userRol !== "7" && (<button
                                                                    type="button"
                                                                    className="btn btn-outline-primary btn-xs"
                                                                    title="Cambiar cobrador"
                                                                    onClick={() => this.Addcobrador(item.id)}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </button>)}
                                                            </div>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-success btn-xs"
                                                                title="Agregar cobrador"
                                                                onClick={() => this.Addcobrador(item.id)}
                                                            >
                                                                +
                                                            </button>
                                                        )}
                                                    </td>
                                                    <td>{item.porcentaje_general + '%' || '-'}</td>
                                                    <td>{item.fecha_expedicion || item.fecha_registro || '-'}</td>
                                                    <td>
                                                        {userRol !== "7" && (
                                                            <button
                                                                className="btn btn-sm btn-primary me-2"
                                                                onClick={() => this.VerRegistros(200, item.id)}
                                                                title="Editar Archivo"
                                                            >
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </button>
                                                        )}
                                                        <button
                                                            className="btn btn-sm btn-warning me-2"
                                                            onClick={() => this.descargarPDFMasivo(item.id)}
                                                            title="Imprimir Historial ClÃƒÂ­nico completo"
                                                        >
                                                            <FontAwesomeIcon icon={faPrint} /> 
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-info"
                                                            onClick={() => this.descargarSeleccionadosPDF()}
                                                            title="Imprimir solo las ÃƒÂ³rdenes seleccionadas"
                                                        >
                                                            <FontAwesomeIcon icon={faPrint} /> 
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10" className="text-center text-muted">
                                                    No hay datos disponibles
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="card-footer">
                            {this.renderRelaciones()}
                        </div>
                    </div>

                    {/* Modal de selecciÃƒÂ³n con bÃƒÂºsqueda */}
                    <div className="modal fade" id="ModalSelect" tabIndex={-1} aria-labelledby="ModalSelectLabel" aria-hidden="true" style={{ zIndex: 99999 }}>
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                            <div className="modal-content bg-dark bg-gradient">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="ModalSelectLabel">
                                        Seleccione un registro
                                    </h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <div className="tab-content" id="pills-tabContent">
                                            <div className="tab-pane fade show active" id="pills-home" role="tabpanel">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="row g-3" id="f1">
                                                            <input
                                                                type="text"
                                                                placeholder="Buscar por ID, nombre o descripciÃƒÂ³n..."
                                                                className="form-control mb-3"
                                                                value={searchTerm}
                                                                onChange={this.handleSearch}
                                                                autoFocus
                                                            />

                                                            {totalModal > 0 && (
                                                                <div className="mb-2 text-muted small">
                                                                    Mostrando {TablaModalVisible.length} de {totalModal} registro(s)
                                                                    {totalModalOriginal > totalModal ? ` filtrados de ${totalModalOriginal}` : ''}
                                                                    {totalModal > TablaModalVisible.length ? '. Escriba para filtrar mas.' : ''}
                                                                </div>
                                                            )}

                                                            <div className="table-responsive" style={{ maxHeight: '400px' }}>
                                                                <table className="table table-hover table-condensed table-sm">
                                                                    <thead className="thead-inverse">
                                                                        <tr>
                                                                            <th className="align-middle">ID</th>
                                                                            <th className="align-middle">DESCRIPCIÃƒÂ“N</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {isLoadingOpen ? (
                                                                            <tr>
                                                                                <td colSpan="2" className="text-center">
                                                                                    <div className="text-center p-3">
                                                                                        <div className="spinner-border text-primary" role="status">
                                                                                            <span className="sr-only">Cargando...</span>
                                                                                        </div>
                                                                                        <p className="mt-2">Cargando datos...</p>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ) : totalModal > 0 ? (
                                                                            TablaModalVisible.map((item, index) => (
                                                                                <tr key={`${item.id}-${index}`} style={{ cursor: 'pointer' }}>
                                                                                    <td>{item.id}</td>
                                                                                    <td>
                                                                                        <a
                                                                                            onClick={() => {
                                                                                                if (modalActivo === 'detalle') {
                                                                                                    this.SeleccionarDetalle(item.id, item.nombre, item.tabla);
                                                                                                } else if (modalActivo === 'cambiarProfesional') {
                                                                                                    this.cambiarProfesionalSubmit(item.id);
                                                                                                } else if (modalActivo === 'cobrador') {
                                                                                                    this.asignarCobradorSubmit(item.id);
                                                                                                } else {
                                                                                                    this.SeleccionarPrincipal(item.id, item.nombre, item.tabla);
                                                                                                }
                                                                                            }}
                                                                                            data-bs-dismiss="modal"
                                                                                            style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'none' }}
                                                                                        >
                                                                                            <ins>{item.nombre || item.descripcion || 'Sin nombre'}</ins>
                                                                                        </a>
                                                                                    </td>
                                                                                </tr>
                                                                            ))
                                                                        ) : (
                                                                            <tr>
                                                                                <td colSpan="2" className="text-center text-muted">
                                                                                    No hay datos disponibles
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal de formulario para la orden principal */}
                    {showFormModalPrincipal && (
                        <div
                            className="modal fade show"
                            id="FormularioModalDetallePrincipal"
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            aria-labelledby="FormularioModalDetallePrincipalLabel"
                            aria-hidden="true"
                            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                        >
                            <div className="modal-dialog modal-xl" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title" id="FormularioModalDetallePrincipalLabel">
                                            {iditem ? 'Editar Orden Interna' : 'Nueva Orden Interna'}
                                        </h4>
                                        <button type="button" className="btn-close" onClick={this.cerrarModalPrincipal} aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <form id="form_registro_detalle_principal">
                                            <div className="card-body">
                                                <ul className="nav nav-tabs" id="pills-tab-principal" role="tablist">
                                                    {TabsPrincipal.map((row, i) => (
                                                        <li key={i} className="nav-item">
                                                            <a
                                                                className={i === 0 ? "nav-link active" : "nav-link"}
                                                                id={`pills-principal-${row.pestana ? row.pestana.replace(/\s+/g, '') : 'general'}-tab`}
                                                                data-bs-toggle="tab"
                                                                href={`#pills-principal-${row.pestana ? row.pestana.replace(/\s+/g, '') : 'general'}`}
                                                                role="tab"
                                                            >
                                                                {row.pestana == null ? "DATOS BASICOS" : row.pestana}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>

                                                <div className="tab-content" id="pills-tabContent-principal">
                                                    {TabsPrincipal.map((fila, indexTab) => (
                                                        <div
                                                            key={indexTab}
                                                            className={indexTab === 0 ? "tab-pane fade show active" : "tab-pane fade"}
                                                            id={`pills-principal-${fila.pestana ? fila.pestana.replace(/\s+/g, '') : 'general'}`}
                                                            role="tabpanel"
                                                        >
                                                            <div className="row card-body p-3 border border-top-0">
                                                                {indexTab === 0 && <input type="hidden" id="principal_sub_id" name="id" value={iditem || ''} />}

                                                                {this.renderTabFieldsPrincipal(fila.pestana)}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="modal-footer">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                    disabled={btnGuadarPrincipal === 1}
                                                    onClick={this.savePrincipal}
                                                >
                                                    {btnGuadarPrincipal === 1 ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                            Guardando...
                                                        </>
                                                    ) : (
                                                        "Guardar Registro"
                                                    )}
                                                </button>
                                                <button type="button" className="btn btn-danger btn-sm" onClick={this.cerrarModalPrincipal}>
                                                    Cerrar
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Modal de formulario para tablas hijas */}
                    {showFormModal && (
                        <div
                            className="modal fade show"
                            id="FormularioModalDetalleHijo"
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            aria-labelledby="FormularioModalDetalleHijoLabel"
                            aria-hidden="true"
                            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                        >
                            <div className="modal-dialog modal-xl" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title" id="FormularioModalDetalleHijoLabel">
                                            {this.state.idRegistroDetalle ? 'Editar Registro' : 'Nuevo Registro'} - {TablaRelacionActual || 'Detalle'}
                                        </h4>
                                        <button type="button" className="btn-close" onClick={this.cerrarModalDetalle} aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <form id="form_registro_detalle_hijo">
                                            <div className="card-body">
                                                <ul className="nav nav-tabs" id="pills-tab-detalle" role="tablist">
                                                    {TabsDetalle.map((row, i) => (
                                                        <li key={i} className="nav-item">
                                                            <a
                                                                className={i === 0 ? "nav-link active" : "nav-link"}
                                                                id={`pills-detalle-${row.pestana ? row.pestana.replace(/\s+/g, '') : 'general'}-tab`}
                                                                data-bs-toggle="tab"
                                                                href={`#pills-detalle-${row.pestana ? row.pestana.replace(/\s+/g, '') : 'general'}`}
                                                                role="tab"
                                                            >
                                                                {row.pestana == null ? "DATOS BASICOS" : row.pestana}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>

                                                <div className="tab-content" id="pills-tabContent-detalle">
                                                    {TabsDetalle.map((fila, indexTab) => (
                                                        <div
                                                            key={indexTab}
                                                            className={indexTab === 0 ? "tab-pane fade show active" : "tab-pane fade"}
                                                            id={`pills-detalle-${fila.pestana ? fila.pestana.replace(/\s+/g, '') : 'general'}`}
                                                            role="tabpanel"
                                                        >
                                                            <div className="row card-body p-3 border border-top-0">
                                                                {indexTab === 0 && <input type="hidden" id="detalle_sub_id" name="id" value={this.state.idRegistroDetalle || ''} />}

                                                                {this.renderTabFieldsDetalleOrder(fila.pestana)}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="modal-footer">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                    disabled={btnGuadarDetalle === 1}
                                                    onClick={this.saveDetalle}
                                                >
                                                    {btnGuadarDetalle === 1 ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                            Guardando...
                                                        </>
                                                    ) : (
                                                        "Guardar Registro"
                                                    )}
                                                </button>
                                                <button type="button" className="btn btn-danger btn-sm" onClick={this.cerrarModalDetalle}>
                                                    Cerrar
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* MODAL PARA AGREGAR MASIVAMENTE PRODUCTOS */}
                    {this.state.showModalMasivo && (
                        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header bg-warning">
                                        <h5 className="modal-title">Agregar Productos Masivamente</h5>
                                        <button type="button" className="btn-close" onClick={this.cerrarModalMasivo}></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="d-flex flex-wrap gap-2 mb-3">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => this.aplicarPaquete(1)}
                                            >
                                                <FontAwesomeIcon icon={faBoxOpen} /> PAQUETE DE INSUMOS APLIC MED
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-success"
                                                onClick={() => this.aplicarPaquete(2)}
                                            >
                                                <FontAwesomeIcon icon={faBoxOpen} /> PAQUETE DE CURACIONES
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-info"
                                                onClick={() => this.aplicarPaquete(3)}
                                            >
                                                <FontAwesomeIcon icon={faBoxOpen} /> CAMBIO DE SONDA
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={this.resetFiltrosMasivo}
                                            >
                                                <FontAwesomeIcon icon={faTimes} /> Reset Filtros
                                            </button>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Buscar producto por nombre..."
                                                    value={this.state.busquedaMasivo}
                                                    onChange={this.handleBusquedaMasivoChange}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <select
                                                    className="form-select"
                                                    value={this.state.filtroTipoMasivo}
                                                    onChange={(e) => this.setState({ filtroTipoMasivo: e.target.value, idsPaqueteSeleccionado: null })}
                                                >
                                                    <option value="">Todos los tipos</option>
                                                    <option value="INSUMO">INSUMO</option>
                                                    <option value="MEDICAMENTO">MEDICAMENTO</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="table-responsive" style={{ maxHeight: '400px' }}>
                                            <table className="table table-sm table-striped table-hover">
                                                <thead className="table-light sticky-top">
                                                    <tr>

                                                        <th>Producto</th>
                                                        <th>Tipo</th>
                                                        <th>Forma</th>
                                                        <th>ConcentraciÃƒÂ³n</th>
                                                        <th style={{ width: '100px' }}>Cantidad</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.productosDisponibles
                                                        .filter(p => {
                                                            const matchesNombre = p.nombre.toLowerCase().includes(this.state.busquedaMasivo.toLowerCase());
                                                            const matchesTipo = this.state.filtroTipoMasivo === '' || (p.tipo && p.tipo.toUpperCase() === this.state.filtroTipoMasivo);
                                                            const matchesPaquete = this.state.idsPaqueteSeleccionado === null || this.state.idsPaqueteSeleccionado.includes(p.id);
                                                            return matchesNombre && matchesTipo && matchesPaquete;
                                                        })
                                                        .map(producto => (
                                                            <tr key={producto.id}>

                                                                <td>{producto.nombre}</td>
                                                                <td>{producto.tipo}</td>
                                                                <td>{producto.forma}</td>
                                                                <td>{producto.concentracion}</td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm"
                                                                        min="0"
                                                                        value={this.state.cantidadesMasivo[producto.id] || ''}
                                                                        onChange={(e) => this.handleCantidadMasivoChange(producto.id, e.target.value)}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={this.cerrarModalMasivo}>Cancelar</button>
                                        <button type="button" className="btn btn-primary" onClick={this.guardarMasivoProductos}>Guardar Productos</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Listar;











